import { Router } from "@angular/router";
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpResponse,
} from "@angular/common/http";
import { BundleService } from "src/app/Services/bundleservice.service";

import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { environment } from "src/environments/environment";
import { EnhancedRestrictedAccessComponent } from "../enhanced-restricted-access/enhanced-restricted-access.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { GetContentService } from "src/app/Services/getcontent.service";
import { SelectionRephraseAIComponent } from "../selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { FlowQueryService } from "src/app/shared/flowquery.helper";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { VersionHistoryPanelComponent } from "../version-history-panel/version-history-panel.component";
import { ContentActivityPanelComponent } from "../content-activity-panel/content-activity-panel.component";
import { OrgContextService } from "src/app/Services/org-context.service";
import {
  PromoteStatus,
  promoteStatusFromAudit,
  takeToPublicSteps,
} from "src/app/shared/utils/take-to-public.util";
import {
  PromotePackConfirmDialogComponent,
  PromotePackConfirmDialogData,
} from "src/app/shared/components/promote-pack-confirm-dialog/promote-pack-confirm-dialog.component";
import { FrontlineOpsService } from "src/app/Services/frontline-ops.service";
import {
  ContentActivityService,
  ContentApprovalStatus,
} from "src/app/Services/content-activity.service";
import { KeepLiveChoiceDialogComponent } from "../keep-live-choice-dialog/keep-live-choice-dialog.component";
import { catchError, debounceTime, map, shareReplay } from "rxjs/operators";
import { Observable, Subject, of } from "rxjs";
import { LoadingModalComponent,
  LoadingModalData,
} from "../loading-modal/loading-modal.component";
import {
  isCreatorPlanUser,
  isOrganizationAccountMode,
} from "src/app/shared/utils/plan.util";
import {
  openCreatorPlanUpgradeDialog,
} from "src/app/shared/utils/creator-plan-restrictions.util";
import {
  handleFlowBundlePermissionError,
  isFlowBundlePermissionError,
  handleCreatorPublicOnlyError,
  isCreatorPublicOnlyError,
  handleMaxPublishedFlowsError,
  isMaxPublishedFlowsError,
} from "src/app/shared/utils/guide-limit-error.util";
import {
  handleTrialLimitError,
  isTrialLimitError,
} from "src/app/shared/utils/trial-gate.util";
import { LeaveConfirmationDialogComponent } from "src/app/shared/components/leave-confirmation-dialog/leave-confirmation-dialog.component";
import { FlowNavigationService } from "src/app/Services/flow-navigation.service";
import {
  RestrictedAccessDraft,
  InitialAccessSnapshot,
  buildDraftFromParentState,
  cloneRestrictedAccessDraft,
  hasRestrictedDraftContent,
  buildInitialAccessSnapshot,
  shouldEnrichInitialAccessSnapshot,
} from "src/app/shared/models/restricted-access-draft.model";

type BundleJourneyTabId =
  | "cover"
  | "documents"
  | "pricing"
  | "flows"
  | "access"
  | "summary";

type BundlePublishAccess = "Public" | "Private" | "Restricted";
type BundleSaveMode = "publish" | "draft";
type BundleAccessChoice =
  | "Public"
  | "PrivateToMe"
  | "LinkAccess"
  | "Restricted";

interface BundleJourneyTabConfig {
  id: BundleJourneyTabId;
  label: string;
}

interface BundleCategoryDraft {
  id: string;
  name: string;
  order: number;
  nestedBundles: any[];
  flows: any[];
}

@Component({
  selector: "app-createbundle",
  templateUrl: "./createbundle.component.html",
  styleUrls: ["./createbundle.component.scss"],
})
export class CreatebundleComponent implements OnInit {
  description: string;
  title: string;
  operationInProgress: boolean;
  bundleImageUrl: string;
  fileData: File = null;
  showVideo: boolean;
  showVideoToggle: any;
  fileName: string;
  noResultReturned: boolean;
  addbundleselectedflows: any[] = [];
  userData: any;
  selectedFlowIds: any[];
  showFlows: boolean;

  /** Guides in the main list, plus category guides and nested packs when nesting is on. */
  get packContentCount(): number {
    const flat = this.addbundleselectedflows?.length || 0;
    if (!this.enableNestedBundles) return flat;
    return (this.bundleCategories || []).reduce(
      (sum, c: any) => sum + (c?.flows?.length || 0) + (c?.nestedBundles?.length || 0),
      flat
    );
  }

  /** A guide pack needs at least 2 items. */
  get bFlows(): boolean {
    return this.packContentCount >= 2;
  }
  coverImageUri: any;
  uniqueId: any;
  bundleId: any;
  rowKey: any;
  partitionKey: any;
  CategoryName: any;
  showDeleteContentMenu: boolean;
  showImage: boolean;
  showImagetoggle: any;
  price: any;
  isPaid: boolean;
  creatorRequiresPaidCreation = false;
  supportingDocumentHyperLinks: any[];
  supportingDocumentDocuments: any[];
  documentName: any;
  filename: any;
  sffilelink: any;
  linkName: any;
  hyperLink: any;
  coverPageURI: string;
  coverPosterPageURI: string;
  isAddSupportingDocument: boolean;
  tabIndex: any;
  FlowCount: any;
  noApprovedFlows: any;
  sffilename: any;
  totalSupportingDocuments: number;
  selectedFlow: boolean;
  showMessage: boolean;
  uploadProgress: number;
  posterUrl: string;
  selectedFile: File;
  showPercentage: boolean;
  isLoading: boolean = false;
  progress: number;
  enableTransferAfterPublish: boolean = false;
  showDescriptionExpanded: boolean = false;

  // Loading modal
  loadingModalRef: MatDialogRef<LoadingModalComponent> = null;

  // Thumbnail selection state
  coverThumbnails: string[] = [];
  isCoverThumbnailLoading: boolean = false;
  coverThumbnailError: string = "";
  customCoverThumbnailUploading: boolean = false;
  coverThumbnailUploadProgress: number = 0;
  generatedCoverThumbnailUrl: string = "";
  customCoverThumbnailUrl: string = "";
  customCoverThumbnailFile: File = null;
  thumbnailSelectionMode: "auto" | "upload" | "compare" = "auto";
  isThumbnailDialogOpen = false;
  thumbnailDialogMode: "auto" | "upload" | "compare" = "auto";
  selectedAutoThumbnailUrl: string = "";
  selectedAutoThumbnailFile: File = null;

  // Video player state for thumbnail selection
  videoDuration: number = 0;
  currentVideoTime: number = 0;
  @ViewChild("coverVideoPlayer") coverVideoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild("thumbnailUploadInput")
  thumbnailUploadInput: ElementRef<HTMLInputElement>;

  // Flow selection popup properties
  showAddFlowsPopup: boolean = false;
  tempFlows: any[] = [];
  searchInput: string = "";
  flowSearchNoResultReturned: boolean = false;
  /** Selected publish access for this bundle. */
  bundleAccessType: BundlePublishAccess = "Public";
  /** Access tab UI choice (includes LinkAccess as its own option). */
  bundleAccessChoice: BundleAccessChoice = "Public";
  showMatchingAccessOnly = false;
  restrictedAccessType = "";
  isSearchHidden = false;
  savedAccessFlows: any[] = [];
  savedAccessAdvanced: any = {};
  /** Session draft for Restricted access (preserved when switching access types). */
  restrictedAccessDraft: RestrictedAccessDraft | null = null;
  /** Frozen access loaded when opening edit, used as a reference in Access summary. */
  initialAccessSnapshot: InitialAccessSnapshot | null = null;
  private initialAccessSnapshotLocked = false;
  @ViewChild(EnhancedRestrictedAccessComponent)
  restrictedAccessPanel?: EnhancedRestrictedAccessComponent;
  flowSearchInformation: string =
    "All your guides are shown. Guide pack publish access is set on the Access tab.";
  private flowSearchTerms = new Subject<string>();
  /** When true, flows are ordered for viewers (1st, 2nd…) and persisted as FlowSequence. */
  bundleFlowsSequenced: boolean = false;

  /** When true, editor shows categorized nested bundles + category flows. Default off. */
  enableNestedBundles: boolean = false;
  bundleCategories: BundleCategoryDraft[] = [];
  newCategoryName: string = "";
  showAddNestedBundlesPopup: boolean = false;
  showAddCategoryFlowsPopup: boolean = false;
  activeCategoryIdForPicker: string = null;
  tempNestedBundles: { bundle: any; isSelected: boolean }[] = [];
  tempCategoryFlows: { flow: any; isSelected: boolean; lockedReason?: string | null }[] = [];
  nestedBundleSearchNoResult: boolean = false;
  categoryFlowSearchNoResult: boolean = false;
  categoryFlowSearchInput: string = "";
  nestedBundleSearchInput: string = "";

  /** Organization approval workflow state for org-scoped guide packs. */
  bundleApprovalState: string = "Draft";
  bundleOrganizationId: string | null = null;
  bundleApplicationId: string | null = null;
  bundleTeamId: string | null = null;
  bundleApprovalBusy = false;
  /** True when the saved pack is currently published (BundleStatus Approved). */
  bundleIsLive = false;
  /** Server-side approval / publishing state of the pack being edited. */
  approvalInfo: ContentApprovalStatus | null = null;
  keepLiveBusy = false;
  /** Published guides by other organization members visible to this user (org account mode only). */
  private orgTeamGuides$: Observable<any[]> | null = null;

  /** Derived flow ordering for persistence and view rendering. */
  private buildFlowSequenceModel(): { FlowId: any; Sequence: number }[] {
    if (!Array.isArray(this.addbundleselectedflows)) {
      return [];
    }
    return this.addbundleselectedflows
      .map((item, idx) => ({
        FlowId: item?.flow?.rowKey,
        Sequence: idx + 1,
      }))
      .filter((x) => x.FlowId !== null && x.FlowId !== undefined && `${x.FlowId}`.trim() !== "");
  }

  // Journey tabs structure
  /** Organization guide packs are never sold, so the Pricing step is skipped. */
  bundleJourneyTabs: BundleJourneyTabConfig[] = [
    { id: "cover", label: "Guide Pack Title" },
    { id: "documents", label: "Supporting Documents" },
    { id: "flows", label: "Guides" },
    { id: "pricing", label: "Pricing" },
    { id: "access", label: "Access" },
    { id: "summary", label: "Summary" },
  ].filter(
    (t) => t.id !== "pricing" || !isOrganizationAccountMode()
  ) as BundleJourneyTabConfig[];
  activeBundleJourneyTab: BundleJourneyTabId = "cover";
  private visitedBundleTabs: Set<BundleJourneyTabId> = new Set<BundleJourneyTabId>();

  private ensureBundleUniqueId(): string {
    if (this.uniqueId !== null && this.uniqueId !== undefined) {
      const current = `${this.uniqueId}`.trim();
      if (current) {
        return current;
      }
    }
    // Keep a deterministic non-empty ID for create flows if backend rejects empty UniqueId.
    const generated = `${Date.now()}`;
    this.uniqueId = generated;
    return generated;
  }

  constructor(
    private router: Router,
    private flowNavigationService: FlowNavigationService,
    private http: HttpClient,
    private bundleService: BundleService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private getContentService: GetContentService,
    private cdr: ChangeDetectorRef,
    private flowServiceService: FlowServiceService,
    private flowQueryService: FlowQueryService,
    private mediaUploadService: MediaUploadService,
    private orgContext: OrgContextService,
    private frontlineOps: FrontlineOpsService,
    private contentActivity: ContentActivityService
  ) {
    this.title = "";
    this.description = "";
    this.operationInProgress = false;
    this.selectedFlowIds = [];
    this.supportingDocumentHyperLinks = [];
    this.supportingDocumentDocuments = [];
  }

  openBundleVersionHistoryDialog(): void {
    const logicalId = this.rowKey;
    if (!logicalId) {
      this.toastr.error("Save the guide pack before viewing version history.");
      return;
    }

    this.dialog.open(VersionHistoryPanelComponent, {
      width: "640px",
      data: {
        entityType: "bundle",
        logicalId,
      },
    });
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.applyCreatorPaidOnlyRules();
    let bundle = JSON.parse(localStorage.getItem("createbundledetails"));
    this.addbundleselectedflows =
      JSON.parse(localStorage.getItem("addbundleselectedflows")) || [];

    // Setup search debounce for flow search
    this.flowSearchTerms.pipe(debounceTime(2000)).subscribe(() => {
      localStorage.removeItem("addbundlePageIndex");
      localStorage.setItem("addbundlePageIndex", "0");
      this.performFlowSearch(0);
    });

    // Initialize rowKey and uniqueId
    this.rowKey = null;
    this.uniqueId = "";
    this.partitionKey = null;

    if (bundle != null) {
      // Handle both old format (Title, Description, etc.) and new format (title, description, etc.)
      this.title = bundle.Title || bundle.title || "";
      this.description = bundle.Description || bundle.description || "";
      this.bundleImageUrl = bundle.Url || bundle.url || "";
      this.isPaid = bundle.IsPaid !== undefined ? bundle.IsPaid : (bundle.isPaid !== undefined ? bundle.isPaid : false);
      this.price = bundle.Price !== undefined ? bundle.Price : (bundle.price !== undefined ? bundle.price : 0);
      this.uniqueId = bundle.UniqueId || bundle.uniqueId || "";
      this.rowKey = bundle.RowKey || bundle.rowKey || null;
      this.partitionKey = bundle.PartitionKey || bundle.partitionKey || bundle.customerEmail || null;
      this.coverPosterPageURI =
        bundle.videoThumbNailUrl || bundle.VideoThumbNailUrl || bundle.coverPosterPageURI || "";
      this.applyCreatorPaidOnlyRules();

      // Load supporting documents from localStorage if available
      var supportingDocumentDocuments = JSON.parse(
        localStorage.getItem("BundleSupportingDocumentDocuments")
      );
      var supportingDocumentHyperLinks = JSON.parse(
        localStorage.getItem("BundleSupportingDocumentHyperLinksRequired")
      );

      if (supportingDocumentDocuments != null) {
        this.supportingDocumentDocuments = supportingDocumentDocuments;
      } else if (bundle.supportingDocumentDocuments) {
        this.supportingDocumentDocuments = bundle.supportingDocumentDocuments;
      } else {
        this.supportingDocumentDocuments = [];
      }

      if (supportingDocumentHyperLinks != null) {
        this.supportingDocumentHyperLinks = supportingDocumentHyperLinks;
      } else if (bundle.supportingDocumentHyperLinks) {
        this.supportingDocumentHyperLinks = bundle.supportingDocumentHyperLinks;
      } else {
        this.supportingDocumentHyperLinks = [];
      }

      // Show delete menu if editing existing bundle
      if (this.rowKey != null && this.rowKey != undefined) {
        this.showDeleteContentMenu = true;
      }

      this.bundleOrganizationId = bundle.organizationId || bundle.OrganizationId || null;
      this.bundleApplicationId = bundle.applicationId || bundle.ApplicationId || null;
      this.bundleTeamId = bundle.teamId || bundle.TeamId || null;
      this.bundleIsLive =
        String(bundle.bundleStatus || bundle.BundleStatus || "").toLowerCase() === "approved";
      this.loadBundleApprovalStatus();

      this.isImageOrVideo(this.bundleImageUrl);
      console.log(this.showImage);
      console.log(this.showVideo);

      const seqFlag = bundle.flowsSequenced ?? bundle.FlowsSequenced;
      const seqArr = bundle.flowSequence ?? bundle.FlowSequence;
      if (seqFlag === true) {
        this.bundleFlowsSequenced = true;
      } else if (seqFlag === false) {
        this.bundleFlowsSequenced = false;
      } else {
        this.bundleFlowsSequenced =
          Array.isArray(seqArr) &&
          seqArr.length > 0;
      }

      const nestedFlag =
        bundle.enableNestedBundles ?? bundle.EnableNestedBundles;
      this.enableNestedBundles = nestedFlag === true;
      this.bundleCategories = this.normalizeCategoriesFromStorage(
        bundle.categories ?? bundle.Categories ?? []
      );

      const savedAccess =
        bundle.bundleAccessType ||
        bundle.accessType ||
        bundle.AccessType;
      if (savedAccess != null && `${savedAccess}`.trim() !== "") {
        this.bundleAccessType = this.normalizeBundleAccessType(savedAccess);
      }
      this.restrictedAccessType =
        bundle.restrictedAccessType || bundle.RestrictedAccessType || "";
      this.isSearchHidden =
        bundle.isSearchHidden ?? bundle.IsSearchHidden ?? false;
      this.savedAccessFlows =
        bundle.restrictedAccessFlows || bundle.RestrictedAccessFlows || [];
      this.savedAccessAdvanced = bundle.savedAccessAdvanced || {};
      this.syncBundleAccessChoiceFromFields();
      this.initializeRestrictedAccessDraftFromLoadedState();
      this.captureInitialAccessSnapshotIfNeeded();
      this.updateFlowSearchInformation();
    }

    this.addbundleselectedflows.forEach((element: any) => {
      if (element.flow.price != null) {
        this.selectedFlow = true;
        return;
      }
    });
    if (this.selectedFlow === undefined) {
      this.selectedFlow = false;
    }

    console.log(this.selectedFlow);

    // If cover details were not in `bundle` but localStorage still has preference
    if (bundle == null) {
      try {
        const details = JSON.parse(localStorage.getItem("createbundledetails"));
        if (details && (details.flowsSequenced === true || details.flowsSequenced === false)) {
          this.bundleFlowsSequenced = details.flowsSequenced;
        }
        if (details && (details.enableNestedBundles === true || details.enableNestedBundles === false)) {
          this.enableNestedBundles = details.enableNestedBundles;
        }
        if (details && Array.isArray(details.categories)) {
          this.bundleCategories = this.normalizeCategoriesFromStorage(details.categories);
        }
      } catch {
        /* ignore */
      }
    } else {
      try {
        const details = JSON.parse(localStorage.getItem("createbundledetails"));
        if (
          details &&
          this.bundleCategories.length === 0 &&
          Array.isArray(details.categories)
        ) {
          this.bundleCategories = this.normalizeCategoriesFromStorage(details.categories);
        }
        if (
          details &&
          (details.enableNestedBundles === true || details.enableNestedBundles === false) &&
          (bundle.enableNestedBundles === undefined && bundle.EnableNestedBundles === undefined)
        ) {
          this.enableNestedBundles = details.enableNestedBundles;
        }
      } catch {
        /* ignore */
      }
    }

    // Mark the initially active tab as visited since user is viewing it
    this.visitedBundleTabs.add(this.activeBundleJourneyTab);
    this.initPackBaseline();

    if (
      this.rowKey != null &&
      this.rowKey !== undefined &&
      `${this.rowKey}`.trim() !== "" &&
      `${this.rowKey}` !== "0"
    ) {
      this.loadBundleAccessTypeForEdit(`${this.rowKey}`);
    }
  }
  // originalTitleText!: string;
  // repharaseButtonTitleText: string = "Rephrase text with AI";
  // isTitleRephrased: boolean = false;
  // isTitleRephraseInProgress: boolean = false;

  // async rephraseTitleText(input: string) {

  //   if (input == undefined || input == "") {
  //     this.toastr.warning(
  //       "The Text To Rephrase is required."
  //     );
  //     return;
  //   }

  //   if (!this.isTitleRephrased) {
  //     this.originalTitleText = input;
  //   }

  //   this.isTitleRephrased = true;
  //   this.isTitleRephraseInProgress = true;
  //   console.log(input);
  //   var aiModel = {
  //     textToRephrase: input
  //   };
  //   (await this.getContentService
  //     .getContentFromAI(aiModel))
  //     .subscribe((aiResponse) => {
  //       if (aiResponse) {
  //         console.log(aiResponse);
  //         console.log(aiResponse[0].completions);
  //         this.title = aiResponse[0].completions;
  //         this.isTitleRephraseInProgress = false;
  //       }
  //     });
  //   this.isTitleRephraseInProgress = false;
  // }

  originalTitleText!: string;
  repharaseButtonTitleText: string = "Rephrase text with AI";
  isTitleRephrased: boolean = false;
  isTitleRephraseInProgress: boolean = false;

  GoToOriginalTitleText() {
    this.title = this.originalTitleText;
  }

  openRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.title }, // Pass the text to the dialog
    });
    if (!this.isTitleRephrased) {
      this.originalTitleText = this.title;
    }
    this.isTitleRephraseInProgress = true;
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the title with the rephrased text and show the selected style
        this.title = result.rephrasedText;
        console.log("Selected style:", result.selectedStyle);
        this.isTitleRephrased = true;
        this.isTitleRephraseInProgress = false;
      }
    });
  }
  originalContentTitleText!: string;
  repharaseButtonText: string = "Rephrase text with AI";
  isRephrased: boolean = false;
  isRephraseInProgress: boolean = false;

  GoToOriginalText() {
    this.description = this.originalContentTitleText;
  }

  openDescrptionRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.description }, // Pass the text to the dialog
    });
    if (!this.isRephrased) {
      this.originalContentTitleText = this.description;
      console.log(this.description);
    }
    this.isRephraseInProgress = true;
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the title with the rephrased text and show the selected style
        this.description = result.rephrasedText;
        console.log("Selected style:", result.selectedStyle);
        this.isRephrased = true;
        this.isRephraseInProgress = false;
      }
    });
  }

  // async rephraseDescriptionText(input: string) {

  //   if (input == undefined || input == "") {
  //     this.toastr.warning(
  //       "The Text To Rephrase is required."
  //     );
  //     return;
  //   }

  //   if (!this.isRephrased) {
  //     this.originalContentTitleText = input;
  //   }

  //   this.isRephrased = true;
  //   this.isRephraseInProgress = true;
  //   console.log(input);
  //   var aiModel = {
  //     textToRephrase: input
  //   };
  //   (await this.getContentService
  //     .getContentFromAI(aiModel))
  //     .subscribe((aiResponse) => {
  //       if (aiResponse) {
  //         console.log(aiResponse);
  //         console.log(aiResponse[0].completions);
  //         this.description = aiResponse[0].completions;
  //         this.isRephraseInProgress = false;
  //       }
  //     });
  //   this.isRephraseInProgress = false;

  // }
  saveFlowToServerAccessLevel(
    accessType,
    mode: BundleSaveMode = "publish",
    afterSave?: (rowKey: string) => void
  ) {
    const savingLabel =
      mode === "draft" ? "Saving guide pack draft..." : "Publishing guide pack...";
    const normalizedAccess = this.persistableBundleAccessType(
      this.normalizeBundleAccessType(accessType)
    );
    if (this.normalizeBundleAccessType(normalizedAccess) !== this.bundleAccessType) {
      this.toastr.warning(
        `Publish access must match the type selected in the Access tab (${this.getBundleAccessLabel()}).`
      );
      return;
    }

    // if (this.selectedFlow) {
    //   this.showMessage = true;
    //   this.toastr.warning("Please add price to bundle to publish as you have selected paid flows to be part of this bundle.");
    // }
    // else {
    //this.showMessage = false;

    // Validate required properties before creating bundleModel
    if (!this.userData || !this.userData.emailAddress) {
      this.toastr.error("User data is missing. Please sign in again.");
      return;
    }

    if (!this.title || !this.description || !this.bundleImageUrl) {
      this.toastr.warning(
        "Please ensure title, description, and guide pack image are provided."
      );
      return;
    }

    if (!this.bFlows) {
      this.toastr.warning(
        this.enableNestedBundles
          ? "Please add at least 2 guides or nested guide packs (in the guide list or in categories)."
          : "Please add at least 2 guides to the guide pack."
      );
      return;
    }

    this.noResultReturned = true;
    // Always rebuild ids from the current ordered list to avoid duplicates across attempts.
    this.selectedFlowIds = (this.addbundleselectedflows || []).map(
      (element: any) => element?.flow?.rowKey
    );
    const flowSequence = this.bundleFlowsSequenced
      ? this.buildFlowSequenceModel()
      : [];
    // localStorage.removeItem("createbundledetails");
    // localStorage.removeItem("addbundleselectedflows");

    var bundleModel: any = {
      UniqueId: this.ensureBundleUniqueId(),
      Description: this.description || "",
      CustomerEmail: this.userData.emailAddress,
      UserName: this.userData.userName || this.userData.uname || "",
      Title: this.title || "",
      AccessType: normalizedAccess,
      ...this.buildRestrictedBundleFields(),
      Url: this.bundleImageUrl || "",
      VideoThumbNailUrl: this.savableCoverPosterUrl,
      Type: "Bundle",
      BundleStatus: mode === "draft" ? "Submitted" : "Approved",
      FlowIds: this.selectedFlowIds || [],
      FlowsSequenced: this.bundleFlowsSequenced,
      FlowSequence: flowSequence,
      EnableNestedBundles: this.enableNestedBundles === true,
      Categories: this.enableNestedBundles
        ? this.buildCategoriesPayload()
        : [],
      Price: this.price || 0,
      IsPaid: this.isPaid || false,
      FlowSupportingDocumentsHyperLinkModels:
        this.supportingDocumentHyperLinks || [],
      FlowSupportingDocumentsDocumentModels:
        this.supportingDocumentDocuments || [],
      //this.configProvider.ApprovedStatus,
    };

    // Include rowKey for edits (supports numeric keys and GUID/string keys)
    if (this.rowKey !== null && this.rowKey !== undefined && `${this.rowKey}`.trim() !== "" && `${this.rowKey}` !== "0") {
      bundleModel.RowKey = this.rowKey.toString();
      bundleModel.UniqueId = this.uniqueId;
      bundleModel.PartitionKey = this.partitionKey || this.userData.emailAddress;
    }

    console.log("Validated bundleModel:", bundleModel);

    if (this.userData != null) {
      this.noResultReturned = true;
      this.progress = 0;
      this.openLoadingModal(savingLabel, true);
      if (this.selectedFlow === true) {
        if (bundleModel.Price != null) {
          this.bundleService
            .PostBundle(bundleModel, this.userData.emailAddress)
            .subscribe({
              next: (event: HttpEvent<any>) => {
                switch (event.type) {
                  case HttpEventType.Sent:
                    console.log("Request sent to server.");
                    break;

                  case HttpEventType.UploadProgress:
                    this.progress = Math.round(
                      (95 * event.loaded) / (event.total || 1)
                    );
                    this.updateLoadingModal(savingLabel, this.progress);
                    console.log(`Progress: ${this.progress}%`);
                    break;

                  case HttpEventType.Response:
                    this.handleBundleSaveResponse(event, mode, afterSave);
                    break;

                  default:
                    console.log("Unhandled event:", event);
                }
              },
              error: (err) => this.handleBundleSaveError(err, mode),
            });
        } else {
          this.closeLoadingModal();
          this.noResultReturned = false;
          this.showMessage = true;
          this.toastr.warning(
            "Please add price to guide pack to publish as you have selected paid guides to be part of this guide pack."
          );
        }
        console.log("Included paid flows also added price", bundleModel);
      } else {
        if (
          bundleModel.Price == null ||
          bundleModel.Price == undefined ||
          bundleModel.Price == 0
        ) {
          this.bundleService
            .PostBundle(bundleModel, this.userData.emailAddress)
            .subscribe({
              next: (event: HttpEvent<any>) => {
                switch (event.type) {
                  case HttpEventType.Sent:
                    console.log("Request sent to server.");
                    break;

                  case HttpEventType.UploadProgress:
                    this.progress = Math.round(
                      (95 * event.loaded) / (event.total || 1)
                    );
                    this.updateLoadingModal(savingLabel, this.progress);
                    console.log(`Progress: ${this.progress}%`);
                    break;

                  case HttpEventType.Response:
                    this.handleBundleSaveResponse(event, mode, afterSave);
                    break;

                  default:
                    console.log("Unhandled event:", event);
                }
              },
              error: (err) => this.handleBundleSaveError(err, mode),
            });
        } else {
          this.closeLoadingModal();
          this.noResultReturned = false;
          this.showMessage = true;
          this.toastr.warning(
            "Please add price to guide pack to publish as you have selected paid guides to be part of this guide pack."
          );
        }
        console.log("Free bundle publish", bundleModel);
      }
    }
  }

  private handleBundleSaveResponse(
    event: HttpResponse<any>,
    mode: BundleSaveMode,
    afterSave?: (rowKey: string) => void
  ): void {
    localStorage.setItem("draftTabIndex", "1");
    const body = event.body || {};

    if (mode === "draft") {
      const savedRowKey = body.rowKey || body.RowKey || this.rowKey;
      if (savedRowKey) {
        this.rowKey = `${savedRowKey}`;
        this.showDeleteContentMenu = true;
      }
      this.uniqueId = body.uniqueId || body.UniqueId || this.uniqueId;
      this.partitionKey =
        body.partitionKey || body.PartitionKey || this.partitionKey;
      this.bundleOrganizationId =
        body.organizationId || body.OrganizationId || this.bundleOrganizationId;
      this.bundleApplicationId =
        body.applicationId || body.ApplicationId || this.bundleApplicationId;
      this.bundleTeamId = body.teamId || body.TeamId || this.bundleTeamId;
      if (body.pendingDraft) {
        // Saved as unpublished edits; the published version stays live.
        this.bundleIsLive = true;
      } else {
        if (this.requiresOrgApproval && this.bundleApprovalState !== "InReview") {
          this.bundleApprovalState = body.approvalState || body.ApprovalState || "Draft";
        }
        this.bundleIsLive = false;
      }
      if (this.requiresOrgApproval && this.bundleApprovalState === "Approved") {
        // The server resets approval when approved content is edited.
        this.bundleApprovalState = "Draft";
      }
      this.syncApprovedPackSnapshot();
      this.capturePackBaseline();
      if (!afterSave) this.loadBundleApprovalStatus();
      this.persistBundleAccessTypeToLocalDetails();
      this.progress = 100;
      this.noResultReturned = false;
      this.closeLoadingModal();
      this.resetProgress();
      this.cdr.detectChanges();
      if (afterSave && this.rowKey) {
        afterSave(this.rowKey);
      } else {
        this.toastr.success("Draft saved");
      }
      return;
    }

    localStorage.removeItem(CreatebundleComponent.SAVED_SNAPSHOT_KEY);
    this.cdr.detectChanges();
    setTimeout(() => {
      this.progress = 100;
      this.updateLoadingModal("Publishing guide pack...", 100);
      this.noResultReturned = false;
      this.closeLoadingModal();
      this.toastr.success("Guide pack successfully published");
      this.router.navigate(["/user-profile"]);
      this.resetProgress();
    }, 5000);
  }

  private handleBundleSaveError(err: any, mode: BundleSaveMode): void {
    console.error("Error saving guide pack:", err);
    this.noResultReturned = false;
    this.closeLoadingModal();
    if (isTrialLimitError(err)) {
      handleTrialLimitError(this.dialog, this.toastr, err, this.router.url);
    } else if (isMaxPublishedFlowsError(err)) {
      handleMaxPublishedFlowsError(this.router, this.toastr, err, this.router.url);
    } else if (isFlowBundlePermissionError(err)) {
      handleFlowBundlePermissionError(this.toastr, err);
    } else if (isCreatorPublicOnlyError(err)) {
      handleCreatorPublicOnlyError(this.dialog, this.router.url, err);
    } else {
      const apiMessage =
        err?.error?.error || err?.error?.message ||
        (typeof err?.error === "string" ? err.error : "");
      this.toastr.error(
        apiMessage ||
          (mode === "draft"
            ? "Failed to save guide pack draft. Please try again."
            : "Failed to publish guide pack. Please try again.")
      );
    }
    this.resetProgress();
  }

  // ---- Organization approval workflow (submit → approve → publish) ----

  get requiresOrgApproval(): boolean {
    return !!(this.bundleOrganizationId || this.orgContext.contentScope().organizationId);
  }

  /** Taking content public is an organization feature; hidden in Public account mode. */
  get showTakeToPublic(): boolean {
    return this.requiresOrgApproval && this.orgContext.isOrganizationMode();
  }

  get canPublishPack(): boolean {
    return (
      !this.requiresOrgApproval ||
      (this.bundleApprovalState === "Approved" && !this.approvedPackEdited)
    );
  }

  /** Same rule as guides: a saved pack that is not in review, and not approved unless edited since. */
  get canSubmitPack(): boolean {
    if (!this.rowKey) return false;
    const state = this.bundleApprovalState || "Draft";
    return state !== "InReview" && (state !== "Approved" || this.approvedPackEdited);
  }

  /** Like guides: an unchanged saved pack can't be re-published, except approved org content. */
  get publishBlockedNoChanges(): boolean {
    return (
      !!this.rowKey &&
      !this.hasUnsavedPackChanges &&
      !(this.requiresOrgApproval && this.bundleApprovalState === "Approved")
    );
  }

  /** Approval covers the reviewed content only; edits after approval must be submitted again. */
  get approvedPackEdited(): boolean {
    if (!this.requiresOrgApproval || this.bundleApprovalState !== "Approved") return false;
    // Any save resets approval on the server, so the last saved state is the approved one.
    const baseline = this.packSavedSnapshot ?? this.approvedPackSnapshot;
    return baseline !== null && this.buildPackSaveSnapshot() !== baseline;
  }

  private approvedPackSnapshot: string | null = null;

  /** Frames picked from a local video are data URLs; only uploaded thumbnails can be stored. */
  private get savableCoverPosterUrl(): string {
    const url = `${this.coverPosterPageURI || ""}`.trim();
    return /^https?:\/\//i.test(url) ? url : "";
  }

  private buildPackContentSnapshot(): string {
    return JSON.stringify({
      title: this.title || "",
      description: this.description || "",
      cover: this.bundleImageUrl || "",
      poster: this.savableCoverPosterUrl,
      flows: (this.addbundleselectedflows || []).map((e: any) => e?.flow?.rowKey || ""),
      sequenced: !!this.bundleFlowsSequenced,
      nested: this.enableNestedBundles === true,
      categories: this.enableNestedBundles
        ? (this.bundleCategories || []).map((c: any) => ({
            name: (c.name || "").trim(),
            nested: (c.nestedBundles || []).map((b: any) => `${b?.rowKey || b?.RowKey || ""}`),
            flows: (c.flows || []).map((f: any) => `${f?.rowKey || f?.RowKey || ""}`),
          }))
        : [],
      price: this.price || 0,
      isPaid: !!this.isPaid,
      links: this.supportingDocumentHyperLinks || [],
      docs: this.supportingDocumentDocuments || [],
    });
  }

  /**
   * Last saved state of an existing pack. Survives reloads of this page (the editor keeps
   * in-progress edits in localStorage), keyed by row key.
   */
  private packSavedSnapshot: string | null = null;
  private awaitingPackBaseline = false;
  private static readonly SAVED_SNAPSHOT_KEY = "createbundleSavedSnapshot";
  /** Set by the guide pack page when it opens the editor with freshly loaded server data. */
  private static readonly FRESH_EDIT_KEY = "createbundleFreshEdit";

  private buildPackSaveSnapshot(): string {
    return JSON.stringify({
      content: this.buildPackContentSnapshot(),
      access: this.bundleAccessType || "",
      restricted: this.restrictedAccessType || "",
      hidden: !!this.isSearchHidden,
      restrictedRules: this.restrictedAccessSignature(),
    });
  }

  /** Restricted users and rules, read live from the Access panel while it is open. */
  private restrictedAccessSignature(): string {
    if (this.bundleAccessType !== "Restricted") return "";
    const draft = this.restrictedAccessPanel?.captureDraftSnapshot();
    const users = draft ? draft.savedAccessFlows : this.savedAccessFlows;
    const adv: any = (draft ? draft.savedAccessAdvanced : this.savedAccessAdvanced) || {};
    return JSON.stringify({
      users: (users || [])
        .map((u: any) => `${u?.EmailAddress || u?.emailAddress || ""}`.trim().toLowerCase())
        .filter((e: string) => !!e)
        .sort(),
      network: !!adv.EnforceNetwork,
      geo: !!adv.EnforceGeo,
      device: !!adv.EnforceDevice,
      companyEmail: !!adv.EnforceCompanyEmail,
      cidrs: adv.AllowedCidrs || "",
      geoFence: adv.GeoFenceJson || "",
      devices: adv.AllowedDeviceIds || "",
      domains: adv.AllowedEmailDomains || "",
    });
  }

  /** True for new packs, and for saved packs whose content or access changed since the last save. */
  get hasUnsavedPackChanges(): boolean {
    if (!this.rowKey || this.packSavedSnapshot === null) return true;
    return this.buildPackSaveSnapshot() !== this.packSavedSnapshot;
  }

  /** The signed-in user owns this pack (reviewers editing someone else's pack in review do not). */
  get isPackAuthor(): boolean {
    if (!this.rowKey) return true;
    const owner = `${this.partitionKey || ""}`.trim().toLowerCase();
    const me = `${this.userData?.emailAddress || ""}`.trim().toLowerCase();
    return !owner || owner === me;
  }

  get canSaveDraft(): boolean {
    return this.isPackAuthor || this.bundleApprovalState !== "InReview";
  }

  private initPackBaseline(): void {
    const key = this.rowKey ? `${this.rowKey}` : "";
    if (!key) {
      localStorage.removeItem(CreatebundleComponent.SAVED_SNAPSHOT_KEY);
      return;
    }
    if (localStorage.getItem(CreatebundleComponent.FRESH_EDIT_KEY) === key) {
      localStorage.removeItem(CreatebundleComponent.FRESH_EDIT_KEY);
      // Access settings finish loading from the server asynchronously; capture after that.
      this.awaitingPackBaseline = true;
      return;
    }
    try {
      const stored = JSON.parse(localStorage.getItem(CreatebundleComponent.SAVED_SNAPSHOT_KEY) || "null");
      if (stored?.rowKey === key && typeof stored.snapshot === "string") {
        this.packSavedSnapshot = stored.snapshot;
      }
    } catch {
      /* unknown baseline: treat as changed */
    }
  }

  private capturePackBaseline(): void {
    this.awaitingPackBaseline = false;
    if (!this.rowKey) return;
    this.packSavedSnapshot = this.buildPackSaveSnapshot();
    localStorage.setItem(
      CreatebundleComponent.SAVED_SNAPSHOT_KEY,
      JSON.stringify({ rowKey: `${this.rowKey}`, snapshot: this.packSavedSnapshot })
    );
  }

  private capturePackBaselineIfAwaiting(): void {
    if (this.awaitingPackBaseline) this.capturePackBaseline();
  }

  private syncApprovedPackSnapshot(): void {
    this.approvedPackSnapshot =
      this.requiresOrgApproval && this.bundleApprovalState === "Approved"
        ? this.buildPackSaveSnapshot()
        : null;
  }

  get bundleApprovalLabel(): string {
    switch (this.bundleApprovalState) {
      case "InReview":
        return "In review";
      case "Approved":
        return this.approvedPackEdited
          ? "Approved — your changes need approval again"
          : "Approved — ready to publish";
      case "Published":
        return this.bundleIsLive ? "Published" : "Published version (draft changes)";
      case "Rejected":
        return "Rejected — revise and resubmit";
      case "Superseded":
        return "Superseded";
      default:
        return "Draft";
    }
  }

  private loadBundleApprovalStatus(): void {
    if (!this.rowKey) return;
    this.contentActivity.approvalStatus("guidePack", `${this.rowKey}`).subscribe({
      next: (status) => {
        this.bundleOrganizationId = status?.organizationId || this.bundleOrganizationId;
        this.bundleApplicationId = status?.applicationId || this.bundleApplicationId;
        this.bundleTeamId = status?.teamId || this.bundleTeamId;
        this.bundleApprovalState = status?.approvalState || "Draft";
        if (typeof status?.isLive === "boolean") this.bundleIsLive = status.isLive;
        this.approvalInfo = status || null;
        this.syncApprovedPackSnapshot();
        this.cdr.detectChanges();
      },
      error: () => {
        /* Status is optional; editing still works without it. */
      },
    });
  }

  /** e.g. "Live: v3 · Editing: v4 (In review)". */
  get publishingStatusLine(): string | null {
    const s = this.approvalInfo;
    if (!s) return null;
    const version = s.version || 0;
    const published = s.publishedVersion || (s.isLive ? version : 0);
    if (s.hasPendingDraft) {
      return `Live: v${published} · Editing: v${version + 1} (${this.bundleApprovalLabel})`;
    }
    if (s.isLive) {
      return `Live: v${version}`;
    }
    if (published > 0 && published < version) {
      return `Published v${published} is hidden · Editing: v${version} (${this.bundleApprovalLabel})`;
    }
    return null;
  }

  get rejectionNotice(): { reason: string; by?: string; atUtc?: string } | null {
    const r = this.approvalInfo?.latestRejection;
    if (!r || this.bundleApprovalState !== "Rejected") return null;
    return {
      reason: (r.comment || "").trim() || "No reason was given.",
      by: r.actorEmail,
      atUtc: r.atUtc,
    };
  }

  /** True while the published version stays visible to the organization during edits. */
  get keepsPublishedLive(): boolean {
    const s = this.approvalInfo;
    return !!s && (!!s.hasPendingDraft || (!!s.isLive && s.keepPublishedLive === true));
  }

  get canChangeKeepLive(): boolean {
    const s = this.approvalInfo;
    if (!s || !this.rowKey) return false;
    return !!s.isLive || !!s.hasPendingDraft || !!s.canRestorePublished;
  }

  get keepLiveChoiceLabel(): string {
    const s = this.approvalInfo;
    if (s?.isLive && !s.hasPendingDraft && s.keepPublishedLive == null) {
      return "Choose what people see while you edit";
    }
    return `${this.keepsPublishedLive ? "Visible while editing" : "Hidden while editing"} · Change`;
  }

  get saveDraftTooltip(): string {
    if (!this.hasUnsavedPackChanges) return "Make changes to save as draft";
    if (!this.bundleIsLive) return "Save without publishing";
    if (this.keepsPublishedLive) {
      return "Saves your changes privately. The published guide pack stays visible until the new version is published.";
    }
    if (this.approvalInfo?.keepPublishedLive == null) {
      return "You'll choose whether the published guide pack stays visible while you edit";
    }
    return "Saving a draft takes the published guide pack offline until the new version is published";
  }

  changeKeepLiveChoice(): void {
    const s = this.approvalInfo;
    if (!s || this.keepLiveBusy) return;
    KeepLiveChoiceDialogComponent.open(this.dialog, {
      kind: "guidePack",
      title: this.title,
      publishedVersion: s.publishedVersion || s.version,
      current: this.keepsPublishedLive,
    }).subscribe((choice) => {
      if (choice === undefined) return;
      const undecided = s.keepPublishedLive == null && !s.hasPendingDraft;
      if (!undecided && choice === this.keepsPublishedLive) return;
      this.setKeepPublishedLive(choice);
    });
  }

  /**
   * Before the first draft save of a published pack, asks whether the published
   * version stays visible. Calls `proceed` once the choice is stored (or right away
   * when no choice is needed).
   */
  private withKeepLiveChoice(proceed: () => void): void {
    const s = this.approvalInfo;
    if (!s || !s.isLive || s.hasPendingDraft || s.keepPublishedLive != null || !this.rowKey) {
      proceed();
      return;
    }
    KeepLiveChoiceDialogComponent.open(this.dialog, {
      kind: "guidePack",
      title: this.title,
      publishedVersion: s.publishedVersion || s.version,
    }).subscribe((choice) => {
      if (choice === undefined) return;
      this.setKeepPublishedLive(choice, proceed);
    });
  }

  private setKeepPublishedLive(keepLive: boolean, then?: () => void): void {
    if (!this.rowKey) return;
    this.keepLiveBusy = true;
    this.frontlineOps.keepPublishedLive("guidePack", `${this.rowKey}`, keepLive).subscribe({
      next: (status) => {
        this.keepLiveBusy = false;
        this.approvalInfo = { ...(this.approvalInfo || {}), ...(status || {}), keepPublishedLive: keepLive };
        if (status?.approvalState) this.bundleApprovalState = status.approvalState;
        if (typeof status?.isLive === "boolean") this.bundleIsLive = status.isLive;
        this.toastr.success(
          keepLive
            ? "The published guide pack stays visible while you edit."
            : "The published guide pack is hidden until the new version is published."
        );
        this.cdr.detectChanges();
        then?.();
      },
      error: (err) => {
        this.keepLiveBusy = false;
        this.toastr.error(err?.error?.error || "Couldn't update this setting. Please try again.");
      },
    });
  }

  private hasValidBundleForSave(): boolean {
    return this.syncRestrictedPanelIntoBundleState();
  }

  saveBundleDraft(): void {
    if (!this.hasValidBundleForSave()) return;
    this.withKeepLiveChoice(() =>
      this.saveFlowToServerAccessLevel(this.bundleAccessType, "draft", () => {
        this.toastr.success("Draft saved");
        this.leave();
      })
    );
  }

  submitBundleForApproval(): void {
    if (!this.hasValidBundleForSave()) return;
    // Reviewers must see exactly what will be published; only save when there are pending edits.
    if (this.rowKey && !this.hasUnsavedPackChanges) {
      this.runBundleApprovalAction(`${this.rowKey}`, "submit");
      return;
    }
    this.withKeepLiveChoice(() =>
      this.saveFlowToServerAccessLevel(this.bundleAccessType, "draft", (rowKey) =>
        this.runBundleApprovalAction(rowKey, "submit")
      )
    );
  }

  canTakeContentToPublic(): boolean {
    return (
      this.requiresOrgApproval &&
      this.orgContext.allowsPublicContentPublish()
    );
  }

  readonly takeToPublicSteps = takeToPublicSteps("guide pack");

  /** Phone footer moves secondary actions into a menu. */
  isMobileView = typeof window !== "undefined" && window.innerWidth <= 768;

  @HostListener("window:resize")
  onWindowResize(): void {
    this.isMobileView = window.innerWidth <= 768;
  }

  get canSubmitPackForApproval(): boolean {
    return this.requiresOrgApproval && this.canSubmitPack && this.isPackAuthor;
  }

  /**
   * Approved or published packs can go public. A live copy also counts: its approval state can
   * read InReview while later edits of a kept-live pack are re-reviewed.
   */
  private get isEligibleForPublic(): boolean {
    if (this.approvalInfo?.isLive || this.bundleIsLive) return true;
    const state = this.approvalInfo?.approvalState || this.bundleApprovalState;
    return state === "Approved" || state === "Published";
  }

  get promoteStatus(): PromoteStatus {
    return promoteStatusFromAudit(this.approvalInfo?.audit);
  }

  get takeToPublicLabel(): string {
    if (this.promoteStatus === "pending") return "Public request pending";
    if (this.promoteStatus === "promoted") return "Update public copy";
    return "Take to public";
  }

  /** Why "Take to public" can't be used yet; empty when it can. */
  get takeToPublicBlockedReason(): string {
    if (!this.orgContext.allowsPublicContentPublish()) {
      return "Your organization doesn't allow publishing to the public catalog. An org admin can turn this on in Org admin > Structure.";
    }
    if (!this.rowKey || !this.isEligibleForPublic) {
      const state = this.approvalInfo?.approvalState || this.bundleApprovalState;
      if (state === "InReview") {
        return "This guide pack is waiting for approval. Once it's approved it goes live in your organization and you can take it to public.";
      }
      return "Submit this guide pack for approval first. Once it's approved it goes live in your organization and you can take it to public.";
    }
    if (this.promoteStatus === "pending") {
      return "Your request is waiting for an approver in Dashboard > Publishing approvals.";
    }
    return "";
  }

  requestPromoteToPublic(): void {
    if (!this.rowKey) {
      this.toastr.warning("Save this guide pack and get it approved first.");
      return;
    }
    if (!this.orgContext.allowsPublicContentPublish()) {
      this.toastr.info(
        "This organization does not allow publishing content to the public catalog."
      );
      return;
    }
    if (!this.isEligibleForPublic) {
      this.toastr.warning("Get this guide pack approved in your organization before taking it to public.");
      return;
    }
    const rowKey = `${this.rowKey}`;
    this.bundleApprovalBusy = true;
    // The guides inside go public with the pack, so the author confirms that list first.
    this.frontlineOps.getPackPublicContents(rowKey).subscribe({
      next: (items) => {
        this.bundleApprovalBusy = false;
        this.dialog
          .open<PromotePackConfirmDialogComponent, PromotePackConfirmDialogData, boolean>(
            PromotePackConfirmDialogComponent,
            {
              width: "520px",
              maxWidth: "94vw",
              autoFocus: false,
              data: { packTitle: this.title, items: items || [], mode: "request" },
            }
          )
          .afterClosed()
          .subscribe((confirmed) => {
            if (confirmed) {
              this.runBundleApprovalAction(rowKey, "requestPromote", { confirmIncludedContent: true });
            }
          });
      },
      error: (err) => {
        this.bundleApprovalBusy = false;
        this.toastr.error(err?.error?.error || "Couldn't load the guides in this pack. Please try again.");
      },
    });
  }

  private runBundleApprovalAction(
    rowKey: string,
    action: "submit" | "requestPromote",
    extra: { confirmIncludedContent?: boolean } = {}
  ): void {
    this.bundleApprovalBusy = true;
    this.frontlineOps
      .approvalAction({
        flowRowKey: rowKey,
        action,
        contentType: "guidePack",
        changeSummary:
          action === "submit"
            ? "Submitted for process-owner / quality review"
            : action === "requestPromote"
            ? "Request to publish publicly under the organization"
            : undefined,
        ...extra,
      })
      .subscribe({
        next: (status: any) => {
          this.bundleApprovalBusy = false;
          if (action !== "requestPromote") {
            this.bundleApprovalState = status?.approvalState || "InReview";
          }
          this.toastr.success(
            action === "requestPromote"
              ? "Request sent. An approver can promote it in Publishing approvals."
              : "Submitted for approval"
          );
          if (action === "submit") {
            this.leave();
            return;
          }
          if (action === "requestPromote") this.loadBundleApprovalStatus();
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.bundleApprovalBusy = false;
          this.toastr.error(err?.error?.error || "Approval action failed");
        },
      });
  }

  openBundleActivityDialog(): void {
    if (!this.rowKey) {
      this.toastr.info("Save the guide pack to start tracking its activity.");
      return;
    }
    ContentActivityPanelComponent.open(this.dialog, {
      contentType: "guidePack",
      contentId: `${this.rowKey}`,
      title: this.title,
    });
  }

  resetProgress() {
    setTimeout(() => {
      this.progress = 0;
      this.isLoading = false;
    }, 500); // Small delay before hiding progress
  }
  restrictedAccessPage(_accessType?: string) {
    this.openBundleRestrictedAccess();
  }
  flowClicked(flow) {
    if (!flow) return;
    localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.setItem("notificationflowId", null);
    localStorage.setItem("navigateTo", "create-guide-pack");
    if (flow.type == "Bundle") {
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      // Generate URL slug for flow
      const slug = this.generateUrlSlug(flow.title);
      this.router.navigate([`/guide/${slug}/${flow.rowKey}`]);
    }
  }

  generateUrlSlug(html: string): string {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .replace(/[^\w\s-]/g, "") // Remove special characters
      .trim()
      .replace(/\s+/g, "-") // Replace spaces with dashes
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  viewUserProfile(flow) {
    if (!flow) return;
    const userFlows = [];
    if (this.userData != null) {
      if (this.userData.emailAddress === flow.customerEmail) {
        userFlows.push(flow);
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      // You may need to import DataService if this is used
      // this.dataService.flowByCategorieschangeMessage(flow);
    } else {
      localStorage.setItem("returnUrl", this.router.url);
      this.router.navigate(["/registration"]);
    }
  }

  showFlowImage(imageUrl: string) {
    // Open image in dialog or new window
    if (imageUrl) {
      window.open(imageUrl, "_blank");
    }
  }

  addflowstoBundle() {
    this.showAddFlowsPopup = true;
    this.getApprovedFlows();
  }

  onMatchingAccessToggleChange(): void {
    if (this.showAddFlowsPopup) {
      this.getApprovedFlows();
    }
    this.updateFlowSearchInformation();
  }

  private initializeRestrictedAccessDraftFromLoadedState(): void {
    const draft = buildDraftFromParentState({
      restrictedAccessType: this.restrictedAccessType,
      isSearchHidden: this.isSearchHidden,
      savedAccessFlows: this.savedAccessFlows,
      savedAccessAdvanced: this.savedAccessAdvanced,
    });
    if (hasRestrictedDraftContent(draft)) {
      this.restrictedAccessDraft = draft;
    }
  }

  private applyRestrictedDraftSnapshot(snapshot: RestrictedAccessDraft): void {
    const draft = cloneRestrictedAccessDraft(snapshot);
    this.restrictedAccessType = draft.restrictedAccessType;
    this.isSearchHidden = draft.isSearchHidden;
    this.savedAccessFlows = draft.savedAccessFlows;
    this.savedAccessAdvanced = draft.savedAccessAdvanced;
  }

  private captureRestrictedAccessDraft(): void {
    if (this.bundleAccessChoice === "Restricted") {
      this.syncRestrictedPanelIntoBundleState({ silent: true });
    }
    this.restrictedAccessDraft = buildDraftFromParentState({
      restrictedAccessType: this.restrictedAccessType,
      isSearchHidden: this.isSearchHidden,
      savedAccessFlows: this.savedAccessFlows,
      savedAccessAdvanced: this.savedAccessAdvanced,
    });
  }

  private restoreRestrictedAccessDraft(): void {
    if (!this.restrictedAccessDraft) {
      return;
    }
    this.applyRestrictedDraftSnapshot(this.restrictedAccessDraft);
  }

  private isEditingExistingBundle(): boolean {
    return !!(this.rowKey && `${this.rowKey}`.trim() !== "" && `${this.rowKey}` !== "0");
  }

  private captureInitialAccessSnapshotIfNeeded(): void {
    if (!this.isEditingExistingBundle() || this.initialAccessSnapshotLocked) {
      return;
    }
    const next = buildInitialAccessSnapshot({
      choice: this.bundleAccessChoice,
      label: this.getBundleAccessLabel() || "Public",
      description: this.getBundleAccessSummaryDescription(),
      savedAccessFlows: this.savedAccessFlows,
      savedAccessAdvanced: this.savedAccessAdvanced,
    });
    if (shouldEnrichInitialAccessSnapshot(this.initialAccessSnapshot, next)) {
      this.initialAccessSnapshot = next;
    }
  }

  private lockInitialAccessSnapshot(): void {
    if (!this.initialAccessSnapshot && this.isEditingExistingBundle()) {
      this.captureInitialAccessSnapshotIfNeeded();
    }
    this.initialAccessSnapshotLocked = true;
  }

  hasInitialAccessSnapshot(): boolean {
    return !!this.initialAccessSnapshot && this.isEditingExistingBundle();
  }

  getInitialAccessLabel(): string {
    return this.initialAccessSnapshot?.label || "";
  }

  getInitialAccessDescription(): string {
    return this.initialAccessSnapshot?.description || "";
  }

  getInitialAccessUserCount(): number {
    return this.initialAccessSnapshot?.userCount || 0;
  }

  getInitialAccessAdvancedLabels(): string[] {
    return this.initialAccessSnapshot?.advancedLabels || [];
  }

  isInitialAccessRestricted(): boolean {
    return this.initialAccessSnapshot?.choice === "Restricted";
  }

  restoreInitialAccessToCurrentSelection(): void {
    const snap = this.initialAccessSnapshot;
    if (!snap) {
      return;
    }
    const choice = snap.choice as BundleAccessChoice;
    if (choice === "Restricted") {
      this.bundleAccessType = "Restricted";
      this.bundleAccessChoice = "Restricted";
      this.restrictedAccessType = "";
      this.isSearchHidden = false;
      this.savedAccessFlows = [];
      this.savedAccessAdvanced = {};
      this.restrictedAccessDraft = null;
      this.setActiveBundleJourneyTab("access");
    } else if (choice === "PrivateToMe") {
      this.setBundleAccessChoice("PrivateToMe");
    } else if (choice === "LinkAccess") {
      this.setBundleAccessChoice("LinkAccess");
    } else {
      this.setBundleAccessChoice("Public");
    }
  }

  setBundleAccessType(accessType: BundlePublishAccess): void {
    if (this.bundleAccessType === accessType && accessType !== "Restricted") {
      return;
    }
    this.bundleAccessType = accessType;
    if (accessType === "Public") {
      this.bundleAccessChoice = "Public";
      this.restrictedAccessType = "";
      this.isSearchHidden = false;
    } else if (accessType === "Private") {
      this.bundleAccessChoice = "PrivateToMe";
      this.restrictedAccessType = "";
      this.isSearchHidden = true;
    } else {
      this.bundleAccessChoice = "Restricted";
    }
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
    if (this.showMatchingAccessOnly && this.showAddFlowsPopup) {
      this.getApprovedFlows();
    }
  }

  isBundleAccessChoiceSelected(choice: BundleAccessChoice): boolean {
    return this.bundleAccessChoice === choice;
  }

  setBundleAccessChoice(choice: BundleAccessChoice): void {
    if (this.blocksCreatorNonPublicAccess(choice)) {
      return;
    }

    if (this.bundleAccessChoice === "Restricted" && choice !== "Restricted") {
      this.captureRestrictedAccessDraft();
    }
    if (this.bundleAccessChoice !== choice) {
      this.lockInitialAccessSnapshot();
    }

    this.bundleAccessChoice = choice;
    if (choice === "Public") {
      this.setBundleAccessType("Public");
      return;
    }
    if (choice === "PrivateToMe") {
      this.setBundleAccessType("Private");
      return;
    }
    if (choice === "LinkAccess") {
      this.bundleAccessType = "Restricted";
      this.restrictedAccessType = "LinkAccess";
      this.isSearchHidden = true;
      this.updateFlowSearchInformation();
      this.persistBundleAccessTypeToLocalDetails();
      return;
    }
    this.bundleAccessType = "Restricted";
    this.restoreRestrictedAccessDraft();
    this.stageBundleAccessModelForPanel();
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
  }

  private stageBundleAccessModelForPanel(): void {
    const bundleModel: any = {
      UniqueId: this.ensureBundleUniqueId(),
      Description: this.description || "",
      CustomerEmail: this.userData?.emailAddress,
      UserName: this.userData?.userName || this.userData?.uname || "",
      Title: this.title || "",
      AccessType: "Restricted",
      accessType: "Restricted",
      RestrictedAccessType: this.restrictedAccessType || "",
      restrictedAccessType: this.restrictedAccessType || "",
      IsSearchHidden: this.isSearchHidden,
      isSearchHidden: this.isSearchHidden,
      restrictedAccessFlows: this.savedAccessFlows || [],
      RestrictedAccessFlows: this.savedAccessFlows || [],
      ...(this.savedAccessAdvanced || {}),
      Type: "Bundle",
      type: "Bundle",
      rowKey: this.rowKey || undefined,
      RowKey: this.rowKey || undefined,
    };
    localStorage.setItem("flowModel", JSON.stringify(bundleModel));
  }

  onEmbeddedBundleAccessConfigured(result: any): void {
    this.applyBundleRestrictedResult(result);
  }

  private syncRestrictedPanelIntoBundleState(options?: { silent?: boolean }): boolean {
    if (this.bundleAccessChoice !== "Restricted") {
      return true;
    }
    const panel = this.restrictedAccessPanel;
    if (!panel) {
      if (options?.silent) {
        return true;
      }
      const hasUsers = (this.savedAccessFlows || []).length > 0;
      const adv = this.savedAccessAdvanced || {};
      const hasAdvanced = !!(
        adv.EnforceNetwork ||
        adv.EnforceGeo ||
        adv.EnforceDevice ||
        adv.EnforceCompanyEmail
      );
      if (!hasUsers && !hasAdvanced) {
        this.toastr.warning(
          "Add users or advanced access rules for Restricted access."
        );
        return false;
      }
      return true;
    }
    if (options?.silent) {
      this.applyRestrictedDraftSnapshot(panel.captureDraftSnapshot());
      return true;
    }
    const result = panel.buildConfigureResult();
    if (!result) {
      this.toastr.warning(
        "Add users or advanced access rules for Restricted access."
      );
      return false;
    }
    this.applyBundleRestrictedResult(result);
    return true;
  }

  /** Publish using Access-tab selection (no access menu). */
  publishWithSelectedAccess(): void {
    if (!this.syncRestrictedPanelIntoBundleState()) {
      return;
    }
    this.publishBundle();
  }

  openBundleRestrictedAccess(): void {
    this.setBundleAccessChoice("Restricted");
  }

  private applyBundleRestrictedResult(result: any): void {
    this.lockInitialAccessSnapshot();
    this.bundleAccessType = "Restricted";
    this.bundleAccessChoice = "Restricted";
    this.restrictedAccessType =
      result.restrictedAccessType || result.RestrictedAccessType || "";
    this.isSearchHidden =
      result.isSearchHidden ?? result.IsSearchHidden ?? false;
    const flows =
      result.restrictedAccessFlows || result.RestrictedAccessFlows;
    if (flows) {
      this.savedAccessFlows = flows;
    }
    this.savedAccessAdvanced = {
      EnforceNetwork: result.enforceNetwork ?? result.EnforceNetwork ?? false,
      EnforceGeo: result.enforceGeo ?? result.EnforceGeo ?? false,
      EnforceDevice: result.enforceDevice ?? result.EnforceDevice ?? false,
      EnforceCompanyEmail:
        result.enforceCompanyEmail ?? result.EnforceCompanyEmail ?? false,
      AllowedCidrs: result.allowedCidrs ?? result.AllowedCidrs ?? "",
      GeoFenceJson: result.geoFenceJson ?? result.GeoFenceJson ?? null,
      AllowedDeviceIds:
        result.allowedDeviceIds ?? result.AllowedDeviceIds ?? "",
      AllowedEmailDomains:
        result.allowedEmailDomains ?? result.AllowedEmailDomains ?? "",
    };
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
    if (this.showMatchingAccessOnly && this.showAddFlowsPopup) {
      this.getApprovedFlows();
    }
  }

  updateFlowSearchInformation(): void {
    if (this.showMatchingAccessOnly) {
      if (this.bundleAccessType === "Private") {
        this.flowSearchInformation =
          "Only your private guides are shown. Turn off the filter below to see all guides.";
      } else if (this.bundleAccessType === "Restricted") {
        this.flowSearchInformation =
          "Only guides matching your guide pack restricted settings are shown. Turn off the filter below to see all guides.";
      } else {
        this.flowSearchInformation =
          "Only your public guides are shown. Turn off the filter below to see all guides.";
      }
      return;
    }
    this.flowSearchInformation =
      "All your guides are shown. Guide pack publish access is set on the Access tab.";
  }

  getBundleAccessLabel(): string {
    if (this.bundleAccessChoice === "LinkAccess") {
      return "Anyone with the link";
    }
    if (this.bundleAccessType === "Private") {
      return "Private to you";
    }
    if (this.bundleAccessType === "Restricted") {
      const restrictedType = String(this.restrictedAccessType || "");
      const users = this.savedAccessFlows || [];
      const adv = this.savedAccessAdvanced || {};
      const hasAdvanced = !!(
        adv.EnforceNetwork ||
        adv.EnforceGeo ||
        adv.EnforceDevice ||
        adv.EnforceCompanyEmail
      );
      if (
        hasAdvanced ||
        users.length > 0 ||
        restrictedType === "SelectedUsers" ||
        restrictedType.toLowerCase() !== "linkaccess"
      ) {
        const bits: string[] = [];
        if (users.length > 0) {
          bits.push(users.length === 1 ? "1 user" : `${users.length} users`);
        }
        if (adv.EnforceNetwork) bits.push("network");
        if (adv.EnforceGeo) bits.push("location");
        if (adv.EnforceDevice) bits.push("devices");
        if (adv.EnforceCompanyEmail) bits.push("email");
        return bits.length ? `Restricted · ${bits.join(", ")}` : "Restricted";
      }
      return "Anyone with the link";
    }
    return "Public";
  }

  getBundleAccessSummaryIcon(): string {
    switch (this.bundleAccessChoice) {
      case "PrivateToMe":
        return "lock";
      case "LinkAccess":
        return "link";
      case "Restricted":
        return "security";
      default:
        return "public";
    }
  }

  getBundleAccessSummaryDescription(): string {
    switch (this.bundleAccessChoice) {
      case "PrivateToMe":
        return "Only you can open this guide pack.";
      case "LinkAccess":
        return "People with the link can open it. Hidden from search.";
      case "Restricted":
        return "Access is limited to selected people and rules.";
      default:
        return "Anyone can find and open this guide pack.";
    }
  }

  hasBundleSavedAccessAdvanced(): boolean {
    const adv = this.savedAccessAdvanced || {};
    return !!(
      adv.EnforceNetwork ||
      adv.EnforceGeo ||
      adv.EnforceDevice ||
      adv.EnforceCompanyEmail
    );
  }

  getFlowAccessBadge(flow: any): string {
    const access = String(flow?.accessType || flow?.AccessType || "").toLowerCase();
    const restricted = String(
      flow?.restrictedAccessType || flow?.RestrictedAccessType || ""
    ).toLowerCase();
    if (access === "private") return "Private";
    if (access === "restricted") {
      if (restricted === "linkaccess") return "Link";
      if (restricted === "selectedusers") return "Restricted";
      return "Restricted";
    }
    return "Public";
  }

  private normalizeBundleAccessType(value: any): BundlePublishAccess {
    const access = String(value || "").toLowerCase();
    if (access === "private") {
      return "Private";
    }
    if (access === "restricted" || access === "linkaccess") {
      return "Restricted";
    }
    return "Public";
  }

  private persistableBundleAccessType(
    accessType: BundlePublishAccess = this.bundleAccessType
  ): "Public" | "Private" | "Restricted" {
    if (accessType === "Private") {
      return "Private";
    }
    if (accessType === "Restricted") {
      return "Restricted";
    }
    return "Public";
  }

  private buildRestrictedBundleFields(): Record<string, any> {
    if (this.bundleAccessType !== "Restricted") {
      return {
        RestrictedAccessType: null,
        IsSearchHidden: this.bundleAccessType !== "Public",
      };
    }
    const adv = this.savedAccessAdvanced || {};
    const restrictedFlows = (this.savedAccessFlows || []).map((u: any) => ({
      EmailAddress: u.emailAddress || u.EmailAddress,
      UserName: u.userName || u.UserName,
      FirstName: u.firstName || u.FirstName,
      ProfilePicUrl: u.profilePicUrl || u.ProfilePicUrl,
    }));
    return {
      RestrictedAccessType: this.restrictedAccessType || null,
      IsSearchHidden: this.isSearchHidden,
      RestrictedAccessFlows: restrictedFlows,
      EnforceNetwork: adv.EnforceNetwork || false,
      EnforceGeo: adv.EnforceGeo || false,
      EnforceDevice: adv.EnforceDevice || false,
      EnforceCompanyEmail: adv.EnforceCompanyEmail || false,
      AllowedCidrs: adv.AllowedCidrs || "",
      GeoFenceJson: adv.GeoFenceJson || null,
      AllowedDeviceIds: adv.AllowedDeviceIds || "",
      AllowedEmailDomains: adv.AllowedEmailDomains || "",
    };
  }

  /** Account the picker lists guides from: the pack's (or active) organization, else personal content. */
  private pickerScope(): { accountScope: string; organizationId?: string } {
    const organizationId =
      this.bundleOrganizationId || this.orgContext.contentScope().organizationId || null;
    return organizationId
      ? { accountScope: "Organization", organizationId }
      : { accountScope: "Personal" };
  }

  private inPickerScope(flow: any): boolean {
    const scope = this.pickerScope();
    const flowOrgId = `${flow?.organizationId || flow?.OrganizationId || ""}`.trim().toLowerCase();
    return scope.accountScope === "Organization"
      ? flowOrgId === `${scope.organizationId}`.trim().toLowerCase()
      : !flowOrgId;
  }

  private queryAccessTypeForFlows(): string {
    if (!this.showMatchingAccessOnly) {
      return "All";
    }
    if (this.bundleAccessType === "Restricted") {
      const rt = String(this.restrictedAccessType || "").toLowerCase();
      if (rt === "linkaccess") {
        return "LinkAccess";
      }
      return "Restricted";
    }
    return this.bundleAccessType;
  }

  publishBundle(): void {
    this.saveFlowToServerAccessLevel(this.bundleAccessType);
  }

  private persistBundleAccessTypeToLocalDetails(): void {
    try {
      const raw = localStorage.getItem("createbundledetails");
      const existing = raw ? JSON.parse(raw) : {};
      existing.accessType = this.bundleAccessType;
      existing.bundleAccessType = this.bundleAccessType;
      existing.restrictedAccessType = this.restrictedAccessType;
      existing.isSearchHidden = this.isSearchHidden;
      existing.restrictedAccessFlows = this.savedAccessFlows;
      existing.savedAccessAdvanced = this.savedAccessAdvanced;
      if (this.rowKey) {
        existing.rowKey = this.rowKey;
        existing.bundleId = this.rowKey;
      }
      localStorage.setItem("createbundledetails", JSON.stringify(existing));
    } catch {
      /* ignore */
    }
  }

  isBundleAccessTypeSelected(accessType: BundlePublishAccess): boolean {
    return this.bundleAccessType === accessType;
  }

  private inferAccessTypeFromFlows(flows: any[]): BundlePublishAccess {
    if (!Array.isArray(flows) || flows.length === 0) {
      return "Public";
    }
    const first = flows[0];
    const access = String(first?.accessType || first?.AccessType || "").toLowerCase();
    const restricted = String(
      first?.restrictedAccessType || first?.RestrictedAccessType || ""
    ).toLowerCase();
    if (access === "private") {
      return "Private";
    }
    if (access === "restricted" || restricted === "linkaccess") {
      return "Restricted";
    }
    return "Public";
  }

  private resolveBundleAccessTypeFromBundle(bundle: any): BundlePublishAccess {
    if (!bundle) {
      return "Public";
    }

    const restrictedType = String(
      bundle.restrictedAccessType || bundle.RestrictedAccessType || ""
    ).toLowerCase();

    const direct =
      bundle.bundleAccessType || bundle.accessType || bundle.AccessType;
    if (direct != null && `${direct}`.trim() !== "") {
      const normalized = this.normalizeBundleAccessType(direct);
      if (normalized === "Restricted" && restrictedType) {
        this.restrictedAccessType =
          bundle.restrictedAccessType || bundle.RestrictedAccessType || "";
        this.isSearchHidden =
          bundle.isSearchHidden ?? bundle.IsSearchHidden ?? false;
      }
      return normalized;
    }

    if (
      String(bundle.accessType || bundle.AccessType || "").toLowerCase() ===
        "restricted" ||
      restrictedType === "linkaccess"
    ) {
      this.restrictedAccessType =
        bundle.restrictedAccessType || bundle.RestrictedAccessType || "LinkAccess";
      this.isSearchHidden =
        bundle.isSearchHidden ?? bundle.IsSearchHidden ?? true;
      return "Restricted";
    }

    const flows = Array.isArray(bundle.flows) ? bundle.flows : [];
    if (flows.length > 0) {
      return this.inferAccessTypeFromFlows(flows);
    }

    return "Public";
  }

  private applyBundleAccessTypeFromSources(
    serverBundle: any,
    bundleId: string
  ): BundlePublishAccess {
    let resolved = this.resolveBundleAccessTypeFromBundle(serverBundle);

    const serverFlows = Array.isArray(serverBundle?.flows)
      ? serverBundle.flows
      : [];
    if (resolved === "Public" && serverFlows.length > 0) {
      const inferred = this.inferAccessTypeFromFlows(serverFlows);
      if (inferred !== "Public") {
        resolved = inferred;
      }
    }

    if (resolved === "Public" && Array.isArray(this.addbundleselectedflows)) {
      const localFlows = this.addbundleselectedflows
        .map((item) => item?.flow)
        .filter(Boolean);
      if (localFlows.length > 0) {
        const inferred = this.inferAccessTypeFromFlows(localFlows);
        if (inferred !== "Public") {
          resolved = inferred;
        }
      }
    }

    return resolved;
  }

  private loadBundleAccessTypeForEdit(bundleId: string): void {
    if (!this.userData?.emailAddress) {
      return;
    }

    const flowQueryModel = new FlowQueryModel({
      BundleId: bundleId,
      userEmail: this.userData.emailAddress,
    });

    this.bundleService.getBundleById(flowQueryModel).subscribe({
      next: (data) => {
        const serverBundle = data?.bundleModel;
        if (serverBundle) {
          this.loadBundleAccessTypeAfterDetails(serverBundle, bundleId);
        } else {
          this.capturePackBaselineIfAwaiting();
        }
      },
      error: () => {
        /* keep localStorage value */
        this.capturePackBaselineIfAwaiting();
      },
    });
  }

  private loadBundleAccessTypeAfterDetails(
    serverBundle: any,
    bundleId: string
  ): void {
    const rowKey =
      serverBundle?.rowKey || serverBundle?.RowKey || bundleId || "";
    let resolved = this.applyBundleAccessTypeFromSources(serverBundle, bundleId);

    if (resolved !== "Public" || !rowKey) {
      if (resolved === "Restricted") {
        this.hydrateBundleRestrictedSettings(serverBundle);
      }
      this.setBundleAccessTypeResolved(resolved);
      return;
    }

    this.flowServiceService.getAccessControl(rowKey).subscribe({
      next: (control) => {
        const access = String(
          control?.accessType || control?.AccessType || ""
        ).toLowerCase();
        const restricted = String(
          control?.restrictedAccessType || control?.RestrictedAccessType || ""
        ).toLowerCase();

        if (access === "private") {
          this.setBundleAccessTypeResolved("Private");
          return;
        }
        if (access === "restricted" || restricted === "linkaccess") {
          this.hydrateBundleRestrictedSettings(control);
          this.setBundleAccessTypeResolved("Restricted");
          return;
        }

        this.setBundleAccessTypeResolved(resolved);
      },
      error: () => this.setBundleAccessTypeResolved(resolved),
    });
  }

  private hydrateBundleRestrictedSettings(source: any): void {
    if (!source) {
      return;
    }
    this.restrictedAccessType =
      source.restrictedAccessType || source.RestrictedAccessType || "";
    this.isSearchHidden =
      source.isSearchHidden ?? source.IsSearchHidden ?? false;
    const flows =
      source.restrictedAccessFlows || source.RestrictedAccessFlows;
    if (flows) {
      this.savedAccessFlows = flows;
    }
    this.savedAccessAdvanced = {
      EnforceNetwork: source.enforceNetwork ?? source.EnforceNetwork ?? false,
      EnforceGeo: source.enforceGeo ?? source.EnforceGeo ?? false,
      EnforceDevice: source.enforceDevice ?? source.EnforceDevice ?? false,
      EnforceCompanyEmail:
        source.enforceCompanyEmail ?? source.EnforceCompanyEmail ?? false,
      AllowedCidrs: source.allowedCidrs ?? source.AllowedCidrs ?? "",
      GeoFenceJson: source.geoFenceJson ?? source.GeoFenceJson ?? null,
      AllowedDeviceIds:
        source.allowedDeviceIds ?? source.AllowedDeviceIds ?? "",
      AllowedEmailDomains:
        source.allowedEmailDomains ?? source.AllowedEmailDomains ?? "",
    };
    this.initializeRestrictedAccessDraftFromLoadedState();
    this.captureInitialAccessSnapshotIfNeeded();
  }

  private setBundleAccessTypeResolved(resolved: BundlePublishAccess): void {
    this.bundleAccessType = resolved;
    this.syncBundleAccessChoiceFromFields();
    this.captureInitialAccessSnapshotIfNeeded();
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
    this.capturePackBaselineIfAwaiting();
    this.cdr.detectChanges();
  }

  private syncBundleAccessChoiceFromFields(): void {
    if (this.bundleAccessType === "Public") {
      this.bundleAccessChoice = "Public";
      return;
    }
    if (this.bundleAccessType === "Private") {
      this.bundleAccessChoice = "PrivateToMe";
      return;
    }
    const restrictedType = String(this.restrictedAccessType || "").toLowerCase();
    const users = this.savedAccessFlows || [];
    const adv = this.savedAccessAdvanced || {};
    const hasAdvanced = !!(
      adv.EnforceNetwork ||
      adv.EnforceGeo ||
      adv.EnforceDevice ||
      adv.EnforceCompanyEmail
    );
    if (restrictedType === "linkaccess" && !users.length && !hasAdvanced) {
      this.bundleAccessChoice = "LinkAccess";
      return;
    }
    this.bundleAccessChoice = "Restricted";
  }

  closeAddFlowsPopup() {
    // Persist selection without destroying existing order:
    // - keep existing selected flows (in their current order)
    // - remove any that are now unchecked
    // - append any newly checked flows at the end
    const newlySelected = (this.tempFlows || []).filter((f) => f?.isSelected);
    const newlySelectedIds = new Set(
      newlySelected.map((x) => `${x?.flow?.rowKey ?? ""}`)
    );

    const existingOrdered = Array.isArray(this.addbundleselectedflows)
      ? [...this.addbundleselectedflows]
      : [];

    const keptExisting = existingOrdered.filter((x) =>
      newlySelectedIds.has(`${x?.flow?.rowKey ?? ""}`)
    );

    const keptExistingIds = new Set(
      keptExisting.map((x) => `${x?.flow?.rowKey ?? ""}`)
    );

    const appended = newlySelected.filter(
      (x) => !keptExistingIds.has(`${x?.flow?.rowKey ?? ""}`)
    );

    const merged = [...keptExisting, ...appended];
    this.addbundleselectedflows = merged;
    localStorage.setItem("addbundleselectedflows", JSON.stringify(merged));

    this.showAddFlowsPopup = false;
    this.cdr.detectChanges();
  }

  getApprovedFlows(): void {
    this.tempFlows = [];
    localStorage.removeItem("addbundlePageIndex");
    localStorage.setItem("addbundlePageIndex", "0");
    this.callServiceForApprovedFlows("0");
  }

  callServiceForApprovedFlows(pageIndex) {
    this.flowSearchNoResultReturned = true;
    this.openLoadingModal("Loading guides...", false);

    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: pageIndex,
      accessType: this.queryAccessTypeForFlows(),
      ...this.pickerScope(),
    });

    this.flowServiceService.getAllUserFlows(flowQueryModel).subscribe({
      next: (data) => {
        this.flowSearchNoResultReturned = false;
        this.closeLoadingModal();
        if (data.flows.length > 0) {
          data.flows.filter((f) => this.inPickerScope(f)).forEach((element) => {
            this.tempFlows.push({ flow: element, isSelected: false });
          });

          // Mark already selected flows
          if (
            this.addbundleselectedflows != null &&
            this.addbundleselectedflows.length > 0
          ) {
            this.addbundleselectedflows.forEach((element: any) => {
              let flow = this.tempFlows.filter(
                (f) => f.flow.rowKey == element.flow.rowKey
              )[0];
              if (flow != null && flow != undefined) flow.isSelected = true;
            });
          }
        }
        if (String(pageIndex) === "0") {
          this.appendOrgTeamGuidesToPicker();
        }
      },
      error: (error) => {
        this.flowSearchNoResultReturned = false;
        this.closeLoadingModal();
        this.toastr.error("Failed to load guides. Please try again.");
        console.error("Error loading flows:", error);
        if (String(pageIndex) === "0") {
          this.appendOrgTeamGuidesToPicker();
        }
      },
    });
  }

  private loadOrgTeamGuides(): Observable<any[]> {
    if (!isOrganizationAccountMode()) return of([]);
    if (!this.orgTeamGuides$) {
      const organizationId = this.pickerScope().organizationId;
      if (!organizationId) return of([]);
      // No app/team filter: the server already limits results to what this member may see.
      this.orgTeamGuides$ = this.flowServiceService
        .getOrgTeamGuides({ organizationId })
        .pipe(
          map((data) => (Array.isArray(data?.flows) ? data.flows : [])),
          catchError(() => {
            this.orgTeamGuides$ = null;
            return of([]);
          }),
          shareReplay(1)
        );
    }
    return this.orgTeamGuides$;
  }

  private orgGuideMatchesPickerFilters(flow: any, searchTerm: string): boolean {
    const wanted = this.queryAccessTypeForFlows();
    if (wanted && wanted !== "All") {
      const actual = String(flow?.accessType || "Public").toLowerCase();
      const target = wanted === "LinkAccess" ? "restricted" : wanted.toLowerCase();
      if (actual !== target) return false;
    }
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return true;
    return [flow?.title, flow?.uniqueId, flow?.userName, flow?.description].some((v) =>
      String(v || "").toLowerCase().includes(q)
    );
  }

  /** Adds other members' published guides to the main guide picker (deduplicated). */
  private appendOrgTeamGuidesToPicker(searchTerm: string = ""): void {
    const target = this.tempFlows;
    this.loadOrgTeamGuides().subscribe((guides) => {
      if (target !== this.tempFlows || !guides.length) return;
      const existing = new Set(target.map((t) => `${t?.flow?.rowKey || ""}`));
      const selected = new Set(
        (this.addbundleselectedflows || []).map((s: any) => `${s?.flow?.rowKey || ""}`)
      );
      guides.forEach((guide) => {
        const id = `${guide?.rowKey || ""}`;
        if (!id || existing.has(id) || !this.orgGuideMatchesPickerFilters(guide, searchTerm)) {
          return;
        }
        existing.add(id);
        target.push({ flow: guide, isSelected: selected.has(id) });
      });
      this.cdr.detectChanges();
    });
  }

  performFlowSearch(pageIndex: number) {
    if (
      this.searchInput == "" ||
      this.searchInput == undefined ||
      this.searchInput == null
    ) {
      this.getApprovedFlows();
    } else {
      this.tempFlows = [];
      localStorage.removeItem("addbundlePageIndex");
      localStorage.setItem("addbundlePageIndex", "0");

      this.flowSearchNoResultReturned = true;
      this.openLoadingModal("Searching guides...", false);

      var flowQueryModel = new FlowQueryModel({
        searchString: this.searchInput,
        userEmail: this.userData.emailAddress,
        pageIndex: pageIndex,
        accessType: this.queryAccessTypeForFlows(),
        ...this.pickerScope(),
      });

      this.flowServiceService.searchInFlows(flowQueryModel).subscribe({
        next: (data) => {
          this.tempFlows = [];
          this.flowSearchNoResultReturned = false;
          this.closeLoadingModal();
          if (data.flows != null && data.flows != undefined) {
            data.flows.filter((f) => this.inPickerScope(f)).forEach((element) => {
              this.tempFlows.push({ flow: element, isSelected: false });
            });

            // Mark already selected flows
            if (
              this.addbundleselectedflows != null &&
              this.addbundleselectedflows.length > 0
            ) {
              this.addbundleselectedflows.forEach((element: any) => {
                let flow = this.tempFlows.filter(
                  (f) => f.flow.rowKey == element.flow.rowKey
                )[0];
                if (flow != null && flow != undefined) flow.isSelected = true;
              });
            }
          }
          this.appendOrgTeamGuidesToPicker(flowQueryModel.searchString);
        },
        error: (error) => {
          this.tempFlows = [];
          this.flowSearchNoResultReturned = false;
          this.closeLoadingModal();
          this.toastr.error("Failed to search guides. Please try again.");
          console.error("Error searching flows:", error);
          this.appendOrgTeamGuidesToPicker(flowQueryModel.searchString);
        },
      });
    }
  }

  searchFlows() {
    this.flowSearchTerms.next("");
  }

  onFlowScroll() {
    var pageIndex = localStorage.getItem("addbundlePageIndex");
    pageIndex = (parseInt(pageIndex) + 1).toString();
    localStorage.setItem("addbundlePageIndex", pageIndex);

    if (
      this.searchInput == "" ||
      this.searchInput == undefined ||
      this.searchInput == null
    ) {
      this.callServiceForApprovedFlows(pageIndex);
    } else {
      this.performFlowSearch(parseInt(pageIndex));
    }
  }

  autoSaveCoverPageData() {
    this.saveCoverPageData();
  }

  saveCoverPageData() {
    if (!this.bundleImageUrl) {
      this.toastr.info("Cover image/video missing");
      return;
    }

    if (!this.description || this.description.trim() === "") {
      this.toastr.info("Guide pack description missing");
      return;
    }

    if (!this.title || this.title.trim() === "") {
      this.toastr.info("Guide pack title missing");
      return;
    }

    // Update cover image/video display flags
    this.isImageOrVideo(this.bundleImageUrl);

    var bundleCoverPage = {
      bundleImage: this.bundleImageUrl,
      description: this.description,
      coverPosterPageURI: this.coverPosterPageURI,
      title: this.title,
      bundleId: this.bundleId,
      uniqueId: this.uniqueId,
      price: this.price,
      isPaid: this.isPaid,
      fileName: this.fileName,
      flowsSequenced: this.bundleFlowsSequenced,
      enableNestedBundles: this.enableNestedBundles === true,
      categories: this.enableNestedBundles
        ? this.serializeCategoriesForStorage()
        : [],
      accessType: this.bundleAccessType,
      bundleAccessType: this.bundleAccessType,
    };

    localStorage.setItem(
      "createbundledetails",
      JSON.stringify(bundleCoverPage)
    );
    this.toastr.success("Guide pack details saved successfully");
  }

  descChanged() {
    // Description changed handler - can be used for auto-save or validation
    // Currently just a placeholder, but can be extended if needed
  }

  checkValue() {
    if (isOrganizationAccountMode()) {
      this.isPaid = false;
      this.price = null;
      return;
    }
    if (this.creatorRequiresPaidCreation) {
      this.isPaid = true;
    }
    if (!this.isPaid) {
      this.price = null;
    }
  }

  private applyCreatorPaidOnlyRules(): void {
    if (isOrganizationAccountMode()) {
      this.creatorRequiresPaidCreation = false;
      this.isPaid = false;
      this.price = null;
      return;
    }
    this.creatorRequiresPaidCreation = isCreatorPlanUser(this.userData);
    if (this.creatorRequiresPaidCreation) {
      this.isPaid = true;
    }
  }

  openCreatorAccessUpgradeDialog(): void {
    openCreatorPlanUpgradeDialog(this.dialog, this.router.url);
  }

  /** Private / link-only require upgrade; Restricted tabs stay open for Creators. */
  private blocksCreatorNonPublicAccess(choice: BundleAccessChoice | "Restricted"): boolean {
    if (
      !this.creatorRequiresPaidCreation ||
      choice === "Public" ||
      choice === "Restricted"
    ) {
      return false;
    }

    this.openCreatorAccessUpgradeDialog();
    return true;
  }

  goToUpgradeForFreeContent(): void {
    this.router.navigate(["/pricing"], {
      queryParams: { upgradeFree: "1" },
    });
  }
  isImageOrVideo(url) {
    const imageExtensions = [
      "jpeg",
      "jpg",
      "jfif",
      "png",
      "tiff",
      "tif",
      "gif",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai", // Added
    ].map((ext) => ext.toLowerCase());

    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "ogg",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi", // Added
    ].map((ext) => ext.toLowerCase());

    const isImage = imageExtensions.some((ext) =>
      url.toLowerCase().includes(ext)
    );
    if (isImage) {
      this.showImage = true;
      this.showVideo = false;
      return;
    }

    const isVideo = videoExtensions.some((ext) =>
      url.toLowerCase().includes(ext)
    );
    if (isVideo) {
      this.showVideo = true;
      this.showImage = false;
      return;
    }

    this.showImage = false;
    this.showVideo = false;
  }

  async selectFiles(event: any, type?: string) {
    if (event.target.files) {
      this.fileData = <File>event.target.files[0];
      this.fileName = this.fileData.name;
      this.noResultReturned = true;
      this.isLoading = true;
      this.progress = 0;
      // Open loading modal
      this.openLoadingModal("Uploading file...", true);

      // Check if it's an image file
      // File type detection
      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "pdf", // From your list, normalized
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob", // From your list
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b", // From your list
        "avi",
        "mts",
        "m2ts",
        "ts",
        "mpg",
        "mpeg",
        "rm",
        "rmvb",
        "divx",
        "xvid",
        "asf",
        "mxf",
        "dv",
        "h264",
        "h265",
        "vp8",
        "vp9",
        "prores",
        "swf",
        "dat",
        "bik",
        "av1",
        "vro",
        "svi",
      ];

      const isImage = imageExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );
      const isVideo = videoExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          this.updateLoadingModal("Optimizing video for upload...", 0);
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(
            this.fileData,
            (progress) => this.updateLoadingModal("Optimizing video for upload...", progress)
          );
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.isLoading = false;
          this.noResultReturned = false;
          this.closeLoadingModal();
          this.fileName = "";
          this.toastr.warning(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      const uploadUrl = isImage
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                break;
              case HttpEventType.ResponseHeader:
                break;
              case HttpEventType.UploadProgress: {
                if (event.total !== undefined) {
                  const progress = (event.loaded / event.total) * 100;
                  if (progress !== 100) {
                    this.progress = Math.round(progress);
                    this.updateLoadingModal(undefined, this.progress);
                  }
                }
                break;
              }
              case HttpEventType.Response:
                this.handleFileUpload(event, isImage);
                break;
            }
          },
          (error) => {
            this.isLoading = false;
            this.noResultReturned = false;
            this.closeLoadingModal();
            this.fileName = "";
            this.toastr.warning(this.mediaUploadService.uploadTooLargeMessage());
            console.error("An error occurred:", error);
          }
        );
    }
  }

  handleFileUpload(res: HttpResponse<any>, isImage: boolean) {
    this.isLoading = false;
    this.noResultReturned = false;
    this.closeLoadingModal();
    const mediaUploadStatus = res.body as any;

    if (mediaUploadStatus != null) {
      if (isImage) {
        this.showImage = true;
        this.showVideo = false;
        this.bundleImageUrl =
          environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
      } else {
        this.showVideo = true;
        this.showImage = false;
        this.bundleImageUrl =
          environment.videoStorageBaseUrl + mediaUploadStatus.fileName;
        this.posterUrl =
          environment.imageStorageBaseUrl + mediaUploadStatus.posterImageName;
        this.coverPosterPageURI = this.posterUrl;
        // Fetch video thumbnails after video upload
        if (mediaUploadStatus.fileName) {
          this.fetchVideoThumbnails(mediaUploadStatus.fileName);
        }
      }
      this.toastr.success("File has been uploaded successfully.");
      this.autoSaveCoverPageData();
    } else {
      // Handle null response
      alert(mediaUploadStatus?.message || "Upload failed");
    }
  }

  deleteBundle(item, index) {
    this.addbundleselectedflows.splice(index, 1);
    localStorage.setItem(
      "addbundleselectedflows",
      JSON.stringify(this.addbundleselectedflows)
    );
  }

  leave() {
    this.flowNavigationService.navigateBackFromBundle(this.rowKey);
  }

  confirmLeave(): void {
    const ref = this.dialog.open(LeaveConfirmationDialogComponent, {
      width: "420px",
      maxWidth: "95vw",
      data: {
        title: "Unsaved changes",
        message:
          "You have unsaved changes. If you leave now your changes will be lost.",
      },
      panelClass: "quick-create-stacked-dialog",
      backdropClass: "quick-create-stacked-dialog-backdrop",
    });

    ref.afterClosed().subscribe((leave: boolean) => {
      if (leave) {
        this.leave();
      }
    });
  }
  close() {
    localStorage.setItem(
      "supportingDocumentDocuments",
      JSON.stringify(this.supportingDocumentDocuments)
    );
    this.router.navigate(["/create-guide"]);
  }

  editLink(index, link) {
    this.linkName = link.linkName;
    this.hyperLink = link.linkUrl;
    localStorage.setItem("editBundlesupportingDocumentHyperLinksIndex", index);
  }

  addLink() {
    var editsupportingDocumentHyperLinksIndex = localStorage.getItem(
      "editBundlesupportingDocumentHyperLinksIndex"
    );
    if (editsupportingDocumentHyperLinksIndex != null) {
      this.supportingDocumentHyperLinks.splice(
        parseInt(editsupportingDocumentHyperLinksIndex),
        1
      );
    }

    this.supportingDocumentHyperLinks.push({
      LinkName: this.linkName,
      LinkUrl: this.hyperLink,
    });

    this.linkName = "";
    this.hyperLink = "";
    localStorage.setItem(
      "BundleSupportingDocumentHyperLinksRequired",
      JSON.stringify(this.supportingDocumentHyperLinks)
    );
    localStorage.removeItem("editBundlesupportingDocumentHyperLinksIndex");

    this.totalSupportingDocuments =
      this.supportingDocumentHyperLinks.length +
      this.supportingDocumentDocuments.length;
  }

  addSupportingDocument() {
    var editSupportingDocumentRequiredIndex = localStorage.getItem(
      "editBundleSupportingDocumentRequiredIndex"
    );

    if (editSupportingDocumentRequiredIndex != null) {
      this.supportingDocumentDocuments.splice(
        parseInt(editSupportingDocumentRequiredIndex),
        1
      );
    }

    this.supportingDocumentDocuments.push({
      DocumentName: this.documentName,
      DocumentUrl: this.sffilelink,
    });

    this.documentName = "";
    this.sffilelink = "";

    localStorage.setItem(
      "BundleSupportingDocumentDocuments",
      JSON.stringify(this.supportingDocumentDocuments)
    );
    localStorage.removeItem("editBundleSupportingDocumentRequiredIndex");

    this.totalSupportingDocuments =
      this.supportingDocumentHyperLinks.length +
      this.supportingDocumentDocuments.length;
  }

  editSupportingDocument(index, document) {
    this.documentName = document.documentName;
    this.sffilelink = document.documentUrl;
    localStorage.setItem("editBundleSupportingDocumentRequiredIndex", index);
  }

  tabChanged(tabChangedEvent) {}

  remove(index) {
    this.supportingDocumentDocuments.splice(index, 1);

    localStorage.setItem(
      "SupportingDocumentDocuments",
      JSON.stringify(this.supportingDocumentDocuments)
    );

    this.totalSupportingDocuments =
      this.supportingDocumentHyperLinks.length +
      this.supportingDocumentDocuments.length;
  }

  removeLink(index) {
    this.supportingDocumentHyperLinks.splice(index, 1);
    localStorage.setItem(
      "SupportingDocumentHyperLinksRequired",
      JSON.stringify(this.supportingDocumentHyperLinks)
    );

    this.totalSupportingDocuments =
      this.supportingDocumentHyperLinks.length +
      this.supportingDocumentDocuments.length;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.supportingDocumentDocuments,
      event.previousIndex,
      event.currentIndex
    );
  }

  dropSelectedFlows(event: CdkDragDrop<any[]>) {
    if (!this.addbundleselectedflows || this.addbundleselectedflows.length === 0) {
      return;
    }
    moveItemInArray(
      this.addbundleselectedflows,
      event.previousIndex,
      event.currentIndex
    );
    localStorage.setItem(
      "addbundleselectedflows",
      JSON.stringify(this.addbundleselectedflows)
    );
    this.cdr.detectChanges();
  }

  /** Keep sequencing preference in createbundledetails when user toggles (no full cover save required). */
  persistFlowsSequencedToLocalDetails(): void {
    try {
      const raw = localStorage.getItem("createbundledetails");
      const existing = raw ? JSON.parse(raw) : {};
      existing.flowsSequenced = this.bundleFlowsSequenced;
      localStorage.setItem("createbundledetails", JSON.stringify(existing));
    } catch {
      /* ignore */
    }
  }

  persistNestedBundlesToLocalDetails(): void {
    try {
      const raw = localStorage.getItem("createbundledetails");
      const existing = raw ? JSON.parse(raw) : {};
      existing.enableNestedBundles = this.enableNestedBundles === true;
      existing.categories = this.enableNestedBundles
        ? this.serializeCategoriesForStorage()
        : [];
      localStorage.setItem("createbundledetails", JSON.stringify(existing));
    } catch {
      /* ignore */
    }
  }

  private newCategoryId(): string {
    return `cat_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  }

  private normalizeCategoriesFromStorage(raw: any[]): BundleCategoryDraft[] {
    if (!Array.isArray(raw)) {
      return [];
    }
    return raw
      .filter((c) => c != null)
      .map((c, index) => ({
        id: `${c.id || c.Id || this.newCategoryId()}`,
        name: `${c.name || c.Name || ""}`.trim(),
        order: Number(c.order || c.Order) > 0 ? Number(c.order || c.Order) : index + 1,
        nestedBundles: this.mergeCategoryItems(
          c.nestedBundles || c.NestedBundles,
          c.nestedBundleIds || c.NestedBundleIds
        ),
        flows: this.mergeCategoryItems(c.flows || c.Flows, c.flowIds || c.FlowIds),
      }))
      .sort((a, b) => a.order - b.order);
  }

  /**
   * Category items come back as full objects, as ids only (unpublished edits), or both;
   * an empty object list must not drop the saved ids.
   */
  private mergeCategoryItems(items: any, ids: any): any[] {
    const list = (Array.isArray(items) ? items : []).filter(
      (x: any) => x && `${x.rowKey || x.RowKey || ""}`.trim()
    );
    const known = new Set(list.map((x: any) => `${x.rowKey || x.RowKey}`.trim()));
    (Array.isArray(ids) ? ids : []).forEach((raw: any) => {
      const id = `${raw ?? ""}`.trim();
      if (!id || known.has(id)) return;
      known.add(id);
      list.push({ rowKey: id, title: id });
    });
    return list;
  }

  /** Picker results only cover what was loaded; keep existing items the picker never listed. */
  private mergePickerSelection(existing: any[], listedIds: Set<string>, selected: any[]): any[] {
    const keyOf = (x: any) => `${x?.rowKey || x?.RowKey || ""}`.trim();
    const selectedById = new Map(selected.map((x) => [keyOf(x), x]));
    const result = (existing || [])
      .filter((x) => !listedIds.has(keyOf(x)) || selectedById.has(keyOf(x)))
      .map((x) => selectedById.get(keyOf(x)) || x);
    const resultIds = new Set(result.map(keyOf));
    return [...result, ...selected.filter((x) => !resultIds.has(keyOf(x)))];
  }

  private serializeCategoriesForStorage(): any[] {
    return (this.bundleCategories || []).map((c, index) => ({
      id: c.id,
      name: c.name,
      order: c.order || index + 1,
      nestedBundles: c.nestedBundles || [],
      flows: c.flows || [],
      NestedBundleIds: (c.nestedBundles || [])
        .map((b) => b?.rowKey || b?.RowKey)
        .filter((id) => !!id),
      FlowIds: (c.flows || [])
        .map((f) => f?.rowKey || f?.RowKey)
        .filter((id) => !!id),
    }));
  }

  private buildCategoriesPayload(): any[] {
    return (this.bundleCategories || [])
      .filter((c) => (c.name || "").trim())
      .map((c, index) => ({
        Id: c.id || this.newCategoryId(),
        Name: (c.name || "").trim(),
        Order: c.order || index + 1,
        NestedBundleIds: (c.nestedBundles || [])
          .map((b) => `${b?.rowKey || b?.RowKey || ""}`.trim())
          .filter((id) => !!id),
        FlowIds: (c.flows || [])
          .map((f) => `${f?.rowKey || f?.RowKey || ""}`.trim())
          .filter((id) => !!id),
      }));
  }

  onEnableNestedBundlesToggle(): void {
    if (!this.enableNestedBundles) {
      this.bundleCategories = [];
      this.newCategoryName = "";
    }
    this.persistNestedBundlesToLocalDetails();
  }

  addBundleCategory(): void {
    const name = (this.newCategoryName || "").trim();
    if (!name) {
      this.toastr.warning("Enter a category name.");
      return;
    }
    const exists = (this.bundleCategories || []).some(
      (c) => (c.name || "").toLowerCase() === name.toLowerCase()
    );
    if (exists) {
      this.toastr.warning("Category name already exists.");
      return;
    }
    this.bundleCategories = [
      ...(this.bundleCategories || []),
      {
        id: this.newCategoryId(),
        name,
        order: (this.bundleCategories?.length || 0) + 1,
        nestedBundles: [],
        flows: [],
      },
    ];
    this.newCategoryName = "";
    this.persistNestedBundlesToLocalDetails();
  }

  removeBundleCategory(categoryId: string): void {
    this.bundleCategories = (this.bundleCategories || []).filter(
      (c) => c.id !== categoryId
    );
    this.bundleCategories.forEach((c, i) => (c.order = i + 1));
    this.persistNestedBundlesToLocalDetails();
  }

  renameBundleCategory(category: BundleCategoryDraft): void {
    const name = (category?.name || "").trim();
    if (!name) {
      this.toastr.warning("Category name is required.");
      return;
    }
    const dup = (this.bundleCategories || []).some(
      (c) => c.id !== category.id && (c.name || "").toLowerCase() === name.toLowerCase()
    );
    if (dup) {
      this.toastr.warning("Category name already exists.");
      return;
    }
    category.name = name;
    this.persistNestedBundlesToLocalDetails();
  }

  openAddNestedBundlesPopup(categoryId: string): void {
    this.activeCategoryIdForPicker = categoryId;
    this.showAddNestedBundlesPopup = true;
    this.nestedBundleSearchInput = "";
    this.loadUserBundlesForNesting();
  }

  closeAddNestedBundlesPopup(): void {
    const category = (this.bundleCategories || []).find(
      (c) => c.id === this.activeCategoryIdForPicker
    );
    if (category) {
      const listed = this.tempNestedBundles || [];
      category.nestedBundles = this.mergePickerSelection(
        category.nestedBundles,
        new Set(listed.map((x) => `${x?.bundle?.rowKey || x?.bundle?.RowKey || ""}`.trim())),
        listed.filter((x) => x.isSelected).map((x) => x.bundle)
      );
      this.persistNestedBundlesToLocalDetails();
    }
    this.showAddNestedBundlesPopup = false;
    this.activeCategoryIdForPicker = null;
    this.tempNestedBundles = [];
  }

  openAddCategoryFlowsPopup(categoryId: string): void {
    this.activeCategoryIdForPicker = categoryId;
    this.showAddCategoryFlowsPopup = true;
    this.searchInput = "";
    this.categoryFlowSearchInput = "";
    this.updateFlowSearchInformation();
    this.loadFlowsForCategoryPicker();
  }

  onCategoryMatchingAccessToggleChange(): void {
    const pending = new Set(
      (this.tempCategoryFlows || [])
        .filter((x) => x.isSelected)
        .map((x) => `${x?.flow?.rowKey || x?.flow?.RowKey || ""}`)
    );
    this.updateFlowSearchInformation();
    this.loadFlowsForCategoryPicker(pending);
  }

  filteredTempCategoryFlows(): { flow: any; isSelected: boolean; lockedReason?: string | null }[] {
    const q = (this.categoryFlowSearchInput || "").trim().toLowerCase();
    if (!q) return this.tempCategoryFlows || [];
    return (this.tempCategoryFlows || []).filter((item) =>
      [item?.flow?.title, item?.flow?.uniqueId, item?.flow?.userName].some((v) =>
        `${v || ""}`.toLowerCase().includes(q)
      )
    );
  }

  closeAddCategoryFlowsPopup(): void {
    const category = (this.bundleCategories || []).find(
      (c) => c.id === this.activeCategoryIdForPicker
    );
    if (category) {
      const listed = this.tempCategoryFlows || [];
      category.flows = this.mergePickerSelection(
        category.flows,
        new Set(listed.map((x) => `${x?.flow?.rowKey || x?.flow?.RowKey || ""}`.trim())),
        listed.filter((x) => x.isSelected).map((x) => x.flow)
      );
      this.persistNestedBundlesToLocalDetails();
    }
    this.showAddCategoryFlowsPopup = false;
    this.activeCategoryIdForPicker = null;
    this.tempCategoryFlows = [];
  }

  removeNestedBundleFromCategory(categoryId: string, bundleRowKey: string): void {
    const category = (this.bundleCategories || []).find((c) => c.id === categoryId);
    if (!category) return;
    category.nestedBundles = (category.nestedBundles || []).filter(
      (b) => `${b?.rowKey || b?.RowKey}` !== `${bundleRowKey}`
    );
    this.persistNestedBundlesToLocalDetails();
  }

  removeFlowFromCategory(categoryId: string, flowRowKey: string): void {
    const category = (this.bundleCategories || []).find((c) => c.id === categoryId);
    if (!category) return;
    category.flows = (category.flows || []).filter(
      (f) => `${f?.rowKey || f?.RowKey}` !== `${flowRowKey}`
    );
    this.persistNestedBundlesToLocalDetails();
  }

  private flatSelectedFlowIdSet(): Set<string> {
    return new Set(
      (this.addbundleselectedflows || [])
        .map((x) => `${x?.flow?.rowKey ?? ""}`)
        .filter((id) => !!id)
    );
  }

  private loadUserBundlesForNesting(): void {
    this.nestedBundleSearchNoResult = true;
    this.tempNestedBundles = [];
    const email = this.userData?.emailAddress;
    if (!email) {
      this.nestedBundleSearchNoResult = false;
      return;
    }
    const flowQueryModel = new FlowQueryModel({
      userEmail: email,
      pageIndex: 0,
    });
    this.flowServiceService.getUserBundles(flowQueryModel).subscribe({
      next: (data) => {
        this.nestedBundleSearchNoResult = false;
        const bundles = data?.bundles || data?.Bundles || [];
        const list = Array.isArray(bundles) ? bundles : [];
        const category = (this.bundleCategories || []).find(
          (c) => c.id === this.activeCategoryIdForPicker
        );
        const selectedIds = new Set(
          (category?.nestedBundles || []).map(
            (b) => `${b?.rowKey || b?.RowKey || ""}`
          )
        );
        const selfKey = `${this.rowKey || ""}`;
        this.tempNestedBundles = list
          .filter((b) => {
            const key = `${b?.rowKey || b?.RowKey || ""}`;
            return key && key !== selfKey && (b?.title || b?.Title);
          })
          .map((b) => ({
            bundle: b,
            isSelected: selectedIds.has(`${b?.rowKey || b?.RowKey || ""}`),
          }));
        this.cdr.detectChanges();
      },
      error: () => {
        this.nestedBundleSearchNoResult = false;
        this.toastr.error("Could not load guide packs for nesting.");
      },
    });
  }

  private loadFlowsForCategoryPicker(pendingSelectedIds?: Set<string>): void {
    this.categoryFlowSearchNoResult = true;
    this.tempCategoryFlows = [];
    this.openLoadingModal("Loading guides...", false);
    const flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: 0,
      accessType: this.queryAccessTypeForFlows(),
      ...this.pickerScope(),
    });
    const category = (this.bundleCategories || []).find(
      (c) => c.id === this.activeCategoryIdForPicker
    );
    const selectedIds =
      pendingSelectedIds ??
      new Set<string>(
        (category?.flows || []).map((f) => `${f?.rowKey || f?.RowKey || ""}`)
      );
    const lockedReason = this.categoryPickerLockedReasonFn(this.activeCategoryIdForPicker);
    const toItem = (flow: any, id: string) => {
      const reason = lockedReason(id);
      return { flow, isSelected: !reason && selectedIds.has(id), lockedReason: reason };
    };

    this.flowServiceService.getAllUserFlows(flowQueryModel).subscribe({
      next: (data) => {
        this.categoryFlowSearchNoResult = false;
        this.closeLoadingModal();
        (data?.flows || []).forEach((element) => {
          const id = `${element?.rowKey || ""}`;
          if (!id || !this.inPickerScope(element)) {
            return;
          }
          this.tempCategoryFlows.push(toItem(element, id));
        });
        this.cdr.detectChanges();
        this.appendOrgTeamGuidesToCategoryPicker(toItem);
      },
      error: () => {
        this.categoryFlowSearchNoResult = false;
        this.closeLoadingModal();
        this.toastr.error("Could not load guides.");
        this.appendOrgTeamGuidesToCategoryPicker(toItem);
      },
    });
  }

  /** Guides already used elsewhere in the pack stay visible in the picker but cannot be picked again. */
  private categoryPickerLockedReasonFn(categoryId: string): (id: string) => string | null {
    const flatIds = this.flatSelectedFlowIdSet();
    const otherCategoryById = new Map<string, string>();
    (this.bundleCategories || []).forEach((c) => {
      if (c.id === categoryId) return;
      (c.flows || []).forEach((f) => {
        const id = `${f?.rowKey || f?.RowKey || ""}`;
        if (id) otherCategoryById.set(id, c.name || "another category");
      });
    });
    return (id: string) => {
      if (flatIds.has(id)) return "Already in guide list";
      const cat = otherCategoryById.get(id);
      return cat ? `In "${cat}"` : null;
    };
  }

  private appendOrgTeamGuidesToCategoryPicker(
    toItem: (flow: any, id: string) => { flow: any; isSelected: boolean; lockedReason: string | null }
  ): void {
    const target = this.tempCategoryFlows;
    this.loadOrgTeamGuides().subscribe((guides) => {
      if (target !== this.tempCategoryFlows || !guides.length) return;
      const listed = new Set(target.map((t) => `${t?.flow?.rowKey || ""}`));
      guides.forEach((guide) => {
        const id = `${guide?.rowKey || ""}`;
        if (!id || listed.has(id) || !this.orgGuideMatchesPickerFilters(guide, "")) {
          return;
        }
        listed.add(id);
        target.push(toItem(guide, id));
      });
      this.cdr.detectChanges();
    });
  }

  filteredTempNestedBundles(): { bundle: any; isSelected: boolean }[] {
    const q = (this.nestedBundleSearchInput || "").trim().toLowerCase();
    if (!q) return this.tempNestedBundles || [];
    return (this.tempNestedBundles || []).filter((item) => {
      const title = `${item?.bundle?.title || item?.bundle?.Title || ""}`.toLowerCase();
      const id = `${item?.bundle?.uniqueId || item?.bundle?.UniqueId || ""}`.toLowerCase();
      return title.includes(q) || id.includes(q);
    });
  }

  /**
   * Handle transfer request after successful publish
   * @param responseBody - Response from publish API containing rowKey and other details
   * @param contentType - Type of content ('flow' or 'bundle')
   */
  handleTransferRequestAfterPublish(
    responseBody: any,
    contentType: "flow" | "bundle"
  ) {
    try {
      // Extract necessary data from response
      const contentId = responseBody.rowKey || responseBody.id;
      const contentTitle = responseBody.title || responseBody.Title;
      const customerEmail =
        responseBody.customerEmail || responseBody.CustomerEmail;

      if (!contentId) {
        console.warn("No content ID found in response for transfer request");
        return;
      }

      // Create transfer request model
      const transferRequest = {
        contentId: contentId,
        contentTitle: contentTitle,
        contentType: contentType,
        fromUserEmail: customerEmail,
        toUserEmail: "", // Will be filled by user in transfer dialog
        requestStatus: "Pending",
        requestDate: new Date().toISOString(),
        description: `Automatic transfer request for ${contentType}: ${contentTitle}`,
      };

      // Store transfer request data for the transfer ownership component
      localStorage.setItem(
        "autoTransferRequest",
        JSON.stringify(transferRequest)
      );

      // Show success message
      this.toastr.success(
        `Transfer request will be created for ${contentType}: ${contentTitle}`
      );

      console.log("Transfer request prepared:", transferRequest);
    } catch (error) {
      console.error("Error preparing transfer request:", error);
      this.toastr.error("Failed to prepare transfer request");
    }
  }

  uploadSupportingDocuments(event) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.openLoadingModal("Uploading document...", true);
      //
      this.fileData = <File>event.target.files[0];
      const formData = new FormData();
      formData.append("fileData", this.fileData);

      // this.isStepCoverPageURISet = true;
      this.isAddSupportingDocument = true;
      if (
        this.fileData.name.includes("pdf") ||
        this.fileData.name.includes("PDF")
      ) {
        this.http
          .post(
            environment.apiBaseUrl + environment.uploadDocumentsUrl,
            formData,
            {
              reportProgress: true,
              observe: "events",
            }
          )
          .subscribe({
            next: (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.UploadProgress:
                  if (event.total) {
                    const progress = Math.round(
                      (event.loaded / event.total) * 100
                    );
                    this.updateLoadingModal("Uploading document...", progress);
                  }
                  break;
                case HttpEventType.Response:
                  var mediaUploadStatus = event.body as any;
                  this.showImage = true;
                  this.showVideo = false;
                  this.noResultReturned = false;
                  this.closeLoadingModal();
                  //
                  if (mediaUploadStatus != null) {
                    this.sffilename = mediaUploadStatus.fileName;
                    this.sffilelink =
                      environment.documentsStorageBaseUrl +
                      mediaUploadStatus.fileName;
                    this.toastr.success("Document uploaded successfully");
                  } else {
                    this.toastr.error(
                      mediaUploadStatus?.message || "Upload failed"
                    );
                  }
                  break;
              }
            },
            error: (error) => {
              this.noResultReturned = false;
              this.closeLoadingModal();
              this.toastr.error("Failed to upload document. Please try again.");
              console.error("Error uploading document:", error);
            },
          });
      } else {
        this.closeLoadingModal();
        this.toastr.warning("Please upload a PDF file");
      }
    }
  }

  // Journey tab navigation methods
  setActiveBundleJourneyTab(tabId: BundleJourneyTabId) {
    // Mark the previous tab as visited when navigating away from it
    const previousTab = this.activeBundleJourneyTab;
    if (previousTab && previousTab !== tabId) {
      this.visitedBundleTabs.add(previousTab);
      if (previousTab === "access" && this.bundleAccessChoice === "Restricted") {
        this.captureRestrictedAccessDraft();
      }
    }
    
    this.activeBundleJourneyTab = tabId;
    // Mark the current tab as visited since user is viewing it
    this.visitedBundleTabs.add(tabId);
    if (tabId === "access" && this.bundleAccessChoice === "Restricted") {
      this.restoreRestrictedAccessDraft();
      this.stageBundleAccessModelForPanel();
    }
  }

  isBundleJourneyStageActive(tabId: BundleJourneyTabId): boolean {
    return this.activeBundleJourneyTab === tabId;
  }

  isBundleJourneyStageComplete(tabId: BundleJourneyTabId): boolean {
    // Mark a tab green once it's been visited (even if optional data wasn't added),
    // as long as it's not the currently active tab.
    return this.visitedBundleTabs.has(tabId) && tabId !== this.activeBundleJourneyTab;
  }

  // Check if mandatory properties are filled for a specific tab
  hasMandatoryPropertiesForTab(tabId: BundleJourneyTabId): boolean {
    switch (tabId) {
      case "cover":
        // Title and cover image are required
        return !!(this.title && this.title.trim() && this.bundleImageUrl);
      case "documents":
        // Documents are optional, always return true
        return true;
      case "pricing":
        // If isPaid is true, price is required; otherwise it's optional
        if (isOrganizationAccountMode()) return true;
        return !this.isPaid || (this.isPaid && this.price && parseFloat(this.price) > 0);
      case "flows":
        return this.bFlows;
      case "access":
        return !!this.bundleAccessChoice;
      case "summary":
        // Summary is accessible after flows
        return true;
      default:
        return true;
    }
  }

  canAccessBundleJourneyTab(tabId: BundleJourneyTabId): boolean {
    const tabIndex = this.bundleJourneyTabs.findIndex((t) => t.id === tabId);
    if (tabIndex === 0) return true; // Cover tab is always accessible
    
    // If editing (rowKey exists), check mandatory properties
    if (this.rowKey != null && this.rowKey != undefined) {
      // Check if all previous tabs have mandatory properties filled
      for (let i = 0; i < tabIndex; i++) {
        const currentTab = this.bundleJourneyTabs[i];
        // Skip documents and access tabs - optional / always have a default
        if (currentTab.id === "documents" || currentTab.id === "access") {
          continue;
        }
        // Check if mandatory properties are filled for this tab
        if (!this.hasMandatoryPropertiesForTab(currentTab.id)) {
          return false;
        }
      }
      return true;
    }
    
    // New creation: same as edit — require mandatory fields on prior tabs.
    // Do not use isBundleJourneyStageComplete here: while the cover tab is active,
    // cover is never "complete" (completion requires leaving the tab), which
    // blocked Next / tab navigation after filling cover details.
    for (let i = 0; i < tabIndex; i++) {
      const currentTab = this.bundleJourneyTabs[i];
      if (currentTab.id === "documents" || currentTab.id === "access") {
        continue;
      }
      if (!this.hasMandatoryPropertiesForTab(currentTab.id)) {
        return false;
      }
    }
    return true;
  }

  getBundleJourneyTabIndex(tabId: BundleJourneyTabId): number {
    return this.bundleJourneyTabs.findIndex((t) => t.id === tabId);
  }

  goToNextBundleJourneyTab() {
    const currentIndex = this.getBundleJourneyTabIndex(
      this.activeBundleJourneyTab
    );
    if (currentIndex < this.bundleJourneyTabs.length - 1) {
      const nextTab = this.bundleJourneyTabs[currentIndex + 1];
      if (this.canAccessBundleJourneyTab(nextTab.id)) {
        this.setActiveBundleJourneyTab(nextTab.id);
      }
    }
  }

  get isLastBundleJourneyTab(): boolean {
    return (
      this.getBundleJourneyTabIndex(this.activeBundleJourneyTab) ===
      this.bundleJourneyTabs.length - 1
    );
  }

  /** Next is disabled on the last tab or until the current tab's required fields are satisfied. */
  get isNextBundleJourneyButtonDisabled(): boolean {
    if (this.isLastBundleJourneyTab) {
      return true;
    }
    return !this.hasMandatoryPropertiesForTab(this.activeBundleJourneyTab);
  }

  getActiveBundleTabLabel(): string {
    const activeTab = this.bundleJourneyTabs.find(
      (tab) => tab.id === this.activeBundleJourneyTab
    );
    return activeTab ? activeTab.label : "Section";
  }

  // Loading modal helper methods
  openLoadingModal(message: string, showProgress: boolean = false) {
    if (this.loadingModalRef) {
      this.closeLoadingModal();
    }
    this.loadingModalRef = this.dialog.open(LoadingModalComponent, {
      width: "400px",
      disableClose: true,
      data: {
        message: message,
        progress: 0,
        showProgress: showProgress,
      } as LoadingModalData,
    });
  }

  updateLoadingModal(message?: string, progress?: number) {
    if (this.loadingModalRef && this.loadingModalRef.componentInstance) {
      if (message) {
        this.loadingModalRef.componentInstance.updateMessage(message);
      }
      if (progress !== undefined) {
        this.loadingModalRef.componentInstance.updateProgress(progress);
      }
    }
  }

  closeLoadingModal() {
    if (this.loadingModalRef) {
      this.loadingModalRef.close();
      this.loadingModalRef = null;
    }
  }

  // Thumbnail selection methods
  openThumbnailDialog(mode: "auto" | "upload" | "compare") {
    this.thumbnailDialogMode = mode;
    this.setThumbnailSelectionMode(mode);
    this.isThumbnailDialogOpen = true;

    if (mode === "auto") {
      this.selectedAutoThumbnailUrl = "";
      this.selectedAutoThumbnailFile = null;
    }

    if (mode === "auto" && this.showVideo && this.bundleImageUrl) {
      setTimeout(() => {
        this.extractFirstThreeFrames();
      }, 300);
    }
  }

  closeThumbnailDialog() {
    this.isThumbnailDialogOpen = false;
  }

  setThumbnailSelectionMode(mode: "auto" | "upload" | "compare") {
    this.thumbnailSelectionMode = mode;
  }

  triggerThumbnailUploadDialog() {
    this.thumbnailSelectionMode = "upload";
    if (this.thumbnailUploadInput) {
      this.thumbnailUploadInput.nativeElement.value = "";
      this.thumbnailUploadInput.nativeElement.click();
    }
  }

  onCustomCoverThumbnailSelect(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size > 2 * 1024 * 1024) {
        this.toastr.warning("File size must be less than 2MB");
        return;
      }
      this.customCoverThumbnailFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customCoverThumbnailUrl = e.target.result;
        this.thumbnailSelectionMode = "upload";
        this.uploadCustomCoverThumbnail();
      };
      reader.readAsDataURL(this.customCoverThumbnailFile);
    }
  }

  uploadCustomCoverThumbnail() {
    if (!this.customCoverThumbnailFile) {
      this.toastr.warning("Please select a thumbnail image");
      return;
    }

    this.customCoverThumbnailUploading = true;
    this.coverThumbnailUploadProgress = 0;
    this.openLoadingModal("Uploading thumbnail...", true);
    const formData = new FormData();
    formData.append("fileData", this.customCoverThumbnailFile);

    this.http
      .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.coverThumbnailUploadProgress = Math.round(
                  (event.loaded / event.total) * 100
                );
                this.updateLoadingModal(
                  "Uploading thumbnail...",
                  this.coverThumbnailUploadProgress
                );
              }
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response && response.fileName) {
                this.customCoverThumbnailUrl =
                  environment.imageStorageBaseUrl + response.fileName;
                this.coverPosterPageURI = this.customCoverThumbnailUrl;
                this.thumbnailSelectionMode = "upload";
                this.customCoverThumbnailFile = null;
                this.customCoverThumbnailUploading = false;
                this.closeLoadingModal();
                this.toastr.success("Custom thumbnail uploaded successfully");
                this.autoSaveCoverPageData();
              }
              break;
          }
        },
        (error) => {
          this.customCoverThumbnailUploading = false;
          this.closeLoadingModal();
          this.toastr.error("Failed to upload thumbnail");
          console.error("Upload error:", error);
        }
      );
  }

  onVideoMetadataLoaded() {
    if (this.coverVideoPlayer?.nativeElement) {
      const video = this.coverVideoPlayer.nativeElement;
      if (!video.crossOrigin) {
        video.crossOrigin = "anonymous";
      }
      this.videoDuration = video.duration;
    }
  }

  onVideoTimeUpdate() {
    if (this.coverVideoPlayer?.nativeElement) {
      this.currentVideoTime = this.coverVideoPlayer.nativeElement.currentTime;
    }
  }

  onScrubberChange(event: any) {
    const time = parseFloat(event.target.value);
    if (this.coverVideoPlayer?.nativeElement) {
      this.coverVideoPlayer.nativeElement.currentTime = time;
      this.currentVideoTime = time;
    }
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }

  captureFrameFromVideo() {
    if (!this.coverVideoPlayer?.nativeElement) {
      return;
    }

    const video = this.coverVideoPlayer.nativeElement;

    if (!video.crossOrigin) {
      video.crossOrigin = "anonymous";
      const currentSrc = video.src;
      video.src = "";
      video.src = currentSrc;
      video.addEventListener(
        "loadedmetadata",
        () => {
          this.performFrameCapture(video);
        },
        { once: true }
      );
      return;
    }

    this.performFrameCapture(video);
  }

  private performFrameCapture(video: HTMLVideoElement) {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");

      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "thumbnail.png", {
              type: "image/png",
            });
            this.customCoverThumbnailFile = file;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.customCoverThumbnailUrl = e.target.result;
              this.thumbnailSelectionMode = "upload";
              this.uploadCustomCoverThumbnail();
            };
            reader.readAsDataURL(file);
          }
        }, "image/png");
      }
    } catch (error) {
      console.error("Error capturing frame:", error);
      this.toastr.error(
        "Unable to capture frame. The video may not support cross-origin access."
      );
    }
  }

  selectAutoThumbnail(thumbnailUrl: string) {
    this.coverPosterPageURI = thumbnailUrl;
    this.selectedAutoThumbnailUrl = thumbnailUrl;
    this.thumbnailSelectionMode = "auto";

    this.convertDataUrlToFile(thumbnailUrl).then((file) => {
      this.selectedAutoThumbnailFile = file;
    });

    this.toastr.success("Thumbnail selected. Click 'Upload' to save it.");
  }

  uploadSelectedAutoThumbnail() {
    if (!this.selectedAutoThumbnailFile) {
      this.toastr.warning("Please select a thumbnail first");
      return;
    }

    this.customCoverThumbnailFile = this.selectedAutoThumbnailFile;
    this.uploadCustomCoverThumbnail();
  }

  extractFirstThreeFrames() {
    if (!this.coverVideoPlayer?.nativeElement || !this.bundleImageUrl) {
      return;
    }

    const video = this.coverVideoPlayer.nativeElement;

    if (!video.crossOrigin) {
      video.crossOrigin = "anonymous";
      const currentSrc = video.src;
      video.src = "";
      video.src = currentSrc;
      video.addEventListener(
        "loadedmetadata",
        () => {
          this.performFrameExtraction(video);
        },
        { once: true }
      );
      return;
    }

    this.performFrameExtraction(video);
  }

  private performFrameExtraction(video: HTMLVideoElement) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return;
    }

    this.isCoverThumbnailLoading = true;
    this.coverThumbnails = [];

    const extractFrames = () => {
      if (
        video.readyState >= 2 &&
        video.videoWidth > 0 &&
        video.videoHeight > 0
      ) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const duration = video.duration || 0;
        if (duration === 0 || isNaN(duration)) {
          this.isCoverThumbnailLoading = false;
          this.coverThumbnailError = "Unable to read video duration";
          return;
        }

        const frameTimes = [
          duration * 0.1,
          duration * 0.5,
          duration * 0.9,
        ].filter((t) => t >= 0 && t <= duration);

        let framesExtracted = 0;
        const totalFrames = frameTimes.length;

        frameTimes.forEach((time, index) => {
          video.currentTime = time;
          video.addEventListener(
            "seeked",
            () => {
              try {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                canvas.toBlob((blob) => {
                  if (blob) {
                    const reader = new FileReader();
                    reader.onload = (e: any) => {
                      this.coverThumbnails.push(e.target.result);
                      framesExtracted++;
                      if (framesExtracted === totalFrames) {
                        this.isCoverThumbnailLoading = false;
                        if (
                          this.coverThumbnails.length > 0 &&
                          !this.coverPosterPageURI
                        ) {
                          this.coverPosterPageURI = this.coverThumbnails[0];
                        }
                      }
                    };
                    reader.readAsDataURL(blob);
                  }
                }, "image/png");
              } catch (error) {
                console.error("Error extracting frame:", error);
                framesExtracted++;
                if (framesExtracted === totalFrames) {
                  this.isCoverThumbnailLoading = false;
                  if (this.coverThumbnails.length === 0) {
                    this.coverThumbnailError =
                      "Unable to extract frames. Please upload a thumbnail manually.";
                  }
                }
              }
            },
            { once: true }
          );
        });
      } else {
        setTimeout(extractFrames, 100);
      }
    };

    extractFrames();
  }

  private async convertDataUrlToFile(dataUrl: string): Promise<File> {
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return new File([blob], "thumbnail.png", { type: "image/png" });
  }

  private fetchVideoThumbnails(fileName: string) {
    if (!fileName) {
      return;
    }

    const url = environment.apiBaseUrl + environment.generateThumbnailsUrl;
    const payload = {
      fileName: fileName,
      count: 3,
    };

    this.isCoverThumbnailLoading = true;
    this.coverThumbnailError = "";
    this.coverThumbnails = [];
    this.openLoadingModal("Generating thumbnails...", false);

    this.http.post(url, payload).subscribe({
      next: (response: any) => {
        const thumbnails = this.normalizeThumbnailResponse(response);
        this.coverThumbnails = thumbnails;
        this.isCoverThumbnailLoading = false;
        this.closeLoadingModal();
        if (thumbnails.length && !this.coverPosterPageURI) {
          this.coverPosterPageURI = thumbnails[0];
        }
        if (!thumbnails.length) {
          this.coverThumbnailError =
            "We couldn't auto-generate thumbnails. Upload one manually.";
        }
      },
      error: (error) => {
        this.isCoverThumbnailLoading = false;
        this.closeLoadingModal();
        this.coverThumbnailError =
          "Unable to generate thumbnails. Please upload one manually.";
        this.toastr.error("Failed to generate thumbnails. Please try again.");
        console.error("Error generating thumbnails:", error);
      },
    });
  }

  private normalizeThumbnailResponse(response: any): string[] {
    if (!response) return [];
    if (Array.isArray(response)) return response;
    if (response.thumbnails && Array.isArray(response.thumbnails)) {
      return response.thumbnails.map((t: any) =>
        typeof t === "string"
          ? t
          : environment.imageStorageBaseUrl + (t.fileName || t.url)
      );
    }
    if (response.thumbnailUrls && Array.isArray(response.thumbnailUrls)) {
      return response.thumbnailUrls;
    }
    return [];
  }
}
